String.prototype.trunc = String.prototype.trunc || function (n) {
    return (this.length > n) ? this.substr(0, n - 1) + '...' : this;
};

String.prototype.dashcase = String.prototype.dashcase || function (n) {

    return this.toLowerCase()
        .replace(/[^\w]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

    // =========================================================
    // return this.toLowerCase().replace(/ /g, '-');
    
    // =========================================================
    let str = this;
    str = this.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    for (var i = 0; i < toReplace.length; ++i) { str = str.replace(toReplace[i], ""); }

    str = str.replace(/\W+/g, "-");
    if (str.charAt(str.length - 1) == "-") { str = str.replace(/-+\z/, ""); }
    if (str.charAt(0) == "-") { str = str.replace(/\A-+/, ""); }

    return str;
};

String.prototype.uuid4 = String.prototype.uuid4 || function () {
    return this + '-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

Number.prototype.toLocal = Number.prototype.toLocal || function (type) {
    const tr = {
        jp: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
    };
    return (tr[type] && tr[type][this]) || this.valueOf();
};

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

/* js-cookie v3.0.0-beta.4 | MIT */
!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self, function () { var r = e.Cookies, n = e.Cookies = t(); n.noConflict = function () { return e.Cookies = r, n } }()) }(this, function () { "use strict"; function e(e) { for (var t = 1; t < arguments.length; t++) { var r = arguments[t]; for (var n in r) e[n] = r[n] } return e } var t = { read: function (e) { return e.replace(/%3B/g, ";") }, write: function (e) { return e.replace(/;/g, "%3B") } }; return function r(n, i) { function o(r, o, u) { if ("undefined" != typeof document) { "number" == typeof (u = e({}, i, u)).expires && (u.expires = new Date(Date.now() + 864e5 * u.expires)), u.expires && (u.expires = u.expires.toUTCString()), r = t.write(r).replace(/=/g, "%3D"), o = n.write(String(o), r); var c = ""; for (var f in u) u[f] && (c += "; " + f, !0 !== u[f] && (c += "=" + u[f].split(";")[0])); return document.cookie = r + "=" + o + c } } return Object.create({ set: o, get: function (e) { if ("undefined" != typeof document && (!arguments.length || e)) { for (var r = document.cookie ? document.cookie.split("; ") : [], i = {}, o = 0; o < r.length; o++) { var u = r[o].split("="), c = u.slice(1).join("="), f = t.read(u[0]).replace(/%3D/g, "="); if (i[f] = n.read(c, f), e === f) break } return e ? i[e] : i } }, remove: function (t, r) { o(t, "", e({}, r, { expires: -1 })) }, withAttributes: function (t) { return r(this.converter, e({}, this.attributes, t)) }, withConverter: function (t) { return r(e({}, this.converter, t), this.attributes) } }, { attributes: { value: Object.freeze(i) }, converter: { value: Object.freeze(n) } }) }(t, { path: "/" }) });

/* https://cdn.jsdelivr.net/npm/js-sha256@0.9.0/src/sha256.min.js */
(function(){"use strict";var ERROR="input is invalid type",WINDOW="object"==typeof window,root=WINDOW?window:{};root.JS_SHA256_NO_WINDOW&&(WINDOW=!1);var WEB_WORKER=!WINDOW&&"object"==typeof self,NODE_JS=!root.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;NODE_JS?root=global:WEB_WORKER&&(root=self);var COMMON_JS=!root.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,AMD="function"==typeof define&&define.amd,ARRAY_BUFFER=!root.JS_SHA256_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,HEX_CHARS="0123456789abcdef".split(""),EXTRA=[-2147483648,8388608,32768,128],SHIFT=[24,16,8,0],K=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],OUTPUT_TYPES=["hex","array","digest","arrayBuffer"],blocks=[];!root.JS_SHA256_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!ARRAY_BUFFER||!root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});var createOutputMethod=function(t,h){return function(r){return new Sha256(h,!0).update(r)[t]()}},createMethod=function(t){var h=createOutputMethod("hex",t);NODE_JS&&(h=nodeWrap(h,t)),h.create=function(){return new Sha256(t)},h.update=function(t){return h.create().update(t)};for(var r=0;r<OUTPUT_TYPES.length;++r){var e=OUTPUT_TYPES[r];h[e]=createOutputMethod(e,t)}return h},nodeWrap=function(method,is224){var crypto=eval("require('crypto')"),Buffer=eval("require('buffer').Buffer"),algorithm=is224?"sha224":"sha256",nodeMethod=function(t){if("string"==typeof t)return crypto.createHash(algorithm).update(t,"utf8").digest("hex");if(null==t)throw new Error(ERROR);return t.constructor===ArrayBuffer&&(t=new Uint8Array(t)),Array.isArray(t)||ArrayBuffer.isView(t)||t.constructor===Buffer?crypto.createHash(algorithm).update(new Buffer(t)).digest("hex"):method(t)};return nodeMethod},createHmacOutputMethod=function(t,h){return function(r,e){return new HmacSha256(r,h,!0).update(e)[t]()}},createHmacMethod=function(t){var h=createHmacOutputMethod("hex",t);h.create=function(h){return new HmacSha256(h,t)},h.update=function(t,r){return h.create(t).update(r)};for(var r=0;r<OUTPUT_TYPES.length;++r){var e=OUTPUT_TYPES[r];h[e]=createHmacOutputMethod(e,t)}return h};function Sha256(t,h){h?(blocks[0]=blocks[16]=blocks[1]=blocks[2]=blocks[3]=blocks[4]=blocks[5]=blocks[6]=blocks[7]=blocks[8]=blocks[9]=blocks[10]=blocks[11]=blocks[12]=blocks[13]=blocks[14]=blocks[15]=0,this.blocks=blocks):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function HmacSha256(t,h,r){var e,s=typeof t;if("string"===s){var i,o=[],a=t.length,H=0;for(e=0;e<a;++e)(i=t.charCodeAt(e))<128?o[H++]=i:i<2048?(o[H++]=192|i>>6,o[H++]=128|63&i):i<55296||i>=57344?(o[H++]=224|i>>12,o[H++]=128|i>>6&63,o[H++]=128|63&i):(i=65536+((1023&i)<<10|1023&t.charCodeAt(++e)),o[H++]=240|i>>18,o[H++]=128|i>>12&63,o[H++]=128|i>>6&63,o[H++]=128|63&i);t=o}else{if("object"!==s)throw new Error(ERROR);if(null===t)throw new Error(ERROR);if(ARRAY_BUFFER&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||ARRAY_BUFFER&&ArrayBuffer.isView(t)))throw new Error(ERROR)}t.length>64&&(t=new Sha256(h,!0).update(t).array());var n=[],S=[];for(e=0;e<64;++e){var c=t[e]||0;n[e]=92^c,S[e]=54^c}Sha256.call(this,h,r),this.update(S),this.oKeyPad=n,this.inner=!0,this.sharedMemory=r}Sha256.prototype.update=function(t){if(!this.finalized){var h,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(ERROR);if(null===t)throw new Error(ERROR);if(ARRAY_BUFFER&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||ARRAY_BUFFER&&ArrayBuffer.isView(t)))throw new Error(ERROR);h=!0}for(var e,s,i=0,o=t.length,a=this.blocks;i<o;){if(this.hashed&&(this.hashed=!1,a[0]=this.block,a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),h)for(s=this.start;i<o&&s<64;++i)a[s>>2]|=t[i]<<SHIFT[3&s++];else for(s=this.start;i<o&&s<64;++i)(e=t.charCodeAt(i))<128?a[s>>2]|=e<<SHIFT[3&s++]:e<2048?(a[s>>2]|=(192|e>>6)<<SHIFT[3&s++],a[s>>2]|=(128|63&e)<<SHIFT[3&s++]):e<55296||e>=57344?(a[s>>2]|=(224|e>>12)<<SHIFT[3&s++],a[s>>2]|=(128|e>>6&63)<<SHIFT[3&s++],a[s>>2]|=(128|63&e)<<SHIFT[3&s++]):(e=65536+((1023&e)<<10|1023&t.charCodeAt(++i)),a[s>>2]|=(240|e>>18)<<SHIFT[3&s++],a[s>>2]|=(128|e>>12&63)<<SHIFT[3&s++],a[s>>2]|=(128|e>>6&63)<<SHIFT[3&s++],a[s>>2]|=(128|63&e)<<SHIFT[3&s++]);this.lastByteIndex=s,this.bytes+=s-this.start,s>=64?(this.block=a[16],this.start=s-64,this.hash(),this.hashed=!0):this.start=s}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296|0,this.bytes=this.bytes%4294967296),this}},Sha256.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,h=this.lastByteIndex;t[16]=this.block,t[h>>2]|=EXTRA[3&h],this.block=t[16],h>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[14]=this.hBytes<<3|this.bytes>>>29,t[15]=this.bytes<<3,this.hash()}},Sha256.prototype.hash=function(){var t,h,r,e,s,i,o,a,H,n=this.h0,S=this.h1,c=this.h2,f=this.h3,A=this.h4,R=this.h5,u=this.h6,_=this.h7,E=this.blocks;for(t=16;t<64;++t)h=((s=E[t-15])>>>7|s<<25)^(s>>>18|s<<14)^s>>>3,r=((s=E[t-2])>>>17|s<<15)^(s>>>19|s<<13)^s>>>10,E[t]=E[t-16]+h+E[t-7]+r|0;for(H=S&c,t=0;t<64;t+=4)this.first?(this.is224?(i=300032,_=(s=E[0]-1413257819)-150054599|0,f=s+24177077|0):(i=704751109,_=(s=E[0]-210244248)-1521486534|0,f=s+143694565|0),this.first=!1):(h=(n>>>2|n<<30)^(n>>>13|n<<19)^(n>>>22|n<<10),e=(i=n&S)^n&c^H,_=f+(s=_+(r=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7))+(A&R^~A&u)+K[t]+E[t])|0,f=s+(h+e)|0),h=(f>>>2|f<<30)^(f>>>13|f<<19)^(f>>>22|f<<10),e=(o=f&n)^f&S^i,u=c+(s=u+(r=(_>>>6|_<<26)^(_>>>11|_<<21)^(_>>>25|_<<7))+(_&A^~_&R)+K[t+1]+E[t+1])|0,h=((c=s+(h+e)|0)>>>2|c<<30)^(c>>>13|c<<19)^(c>>>22|c<<10),e=(a=c&f)^c&n^o,R=S+(s=R+(r=(u>>>6|u<<26)^(u>>>11|u<<21)^(u>>>25|u<<7))+(u&_^~u&A)+K[t+2]+E[t+2])|0,h=((S=s+(h+e)|0)>>>2|S<<30)^(S>>>13|S<<19)^(S>>>22|S<<10),e=(H=S&c)^S&f^a,A=n+(s=A+(r=(R>>>6|R<<26)^(R>>>11|R<<21)^(R>>>25|R<<7))+(R&u^~R&_)+K[t+3]+E[t+3])|0,n=s+(h+e)|0;this.h0=this.h0+n|0,this.h1=this.h1+S|0,this.h2=this.h2+c|0,this.h3=this.h3+f|0,this.h4=this.h4+A|0,this.h5=this.h5+R|0,this.h6=this.h6+u|0,this.h7=this.h7+_|0},Sha256.prototype.hex=function(){this.finalize();var t=this.h0,h=this.h1,r=this.h2,e=this.h3,s=this.h4,i=this.h5,o=this.h6,a=this.h7,H=HEX_CHARS[t>>28&15]+HEX_CHARS[t>>24&15]+HEX_CHARS[t>>20&15]+HEX_CHARS[t>>16&15]+HEX_CHARS[t>>12&15]+HEX_CHARS[t>>8&15]+HEX_CHARS[t>>4&15]+HEX_CHARS[15&t]+HEX_CHARS[h>>28&15]+HEX_CHARS[h>>24&15]+HEX_CHARS[h>>20&15]+HEX_CHARS[h>>16&15]+HEX_CHARS[h>>12&15]+HEX_CHARS[h>>8&15]+HEX_CHARS[h>>4&15]+HEX_CHARS[15&h]+HEX_CHARS[r>>28&15]+HEX_CHARS[r>>24&15]+HEX_CHARS[r>>20&15]+HEX_CHARS[r>>16&15]+HEX_CHARS[r>>12&15]+HEX_CHARS[r>>8&15]+HEX_CHARS[r>>4&15]+HEX_CHARS[15&r]+HEX_CHARS[e>>28&15]+HEX_CHARS[e>>24&15]+HEX_CHARS[e>>20&15]+HEX_CHARS[e>>16&15]+HEX_CHARS[e>>12&15]+HEX_CHARS[e>>8&15]+HEX_CHARS[e>>4&15]+HEX_CHARS[15&e]+HEX_CHARS[s>>28&15]+HEX_CHARS[s>>24&15]+HEX_CHARS[s>>20&15]+HEX_CHARS[s>>16&15]+HEX_CHARS[s>>12&15]+HEX_CHARS[s>>8&15]+HEX_CHARS[s>>4&15]+HEX_CHARS[15&s]+HEX_CHARS[i>>28&15]+HEX_CHARS[i>>24&15]+HEX_CHARS[i>>20&15]+HEX_CHARS[i>>16&15]+HEX_CHARS[i>>12&15]+HEX_CHARS[i>>8&15]+HEX_CHARS[i>>4&15]+HEX_CHARS[15&i]+HEX_CHARS[o>>28&15]+HEX_CHARS[o>>24&15]+HEX_CHARS[o>>20&15]+HEX_CHARS[o>>16&15]+HEX_CHARS[o>>12&15]+HEX_CHARS[o>>8&15]+HEX_CHARS[o>>4&15]+HEX_CHARS[15&o];return this.is224||(H+=HEX_CHARS[a>>28&15]+HEX_CHARS[a>>24&15]+HEX_CHARS[a>>20&15]+HEX_CHARS[a>>16&15]+HEX_CHARS[a>>12&15]+HEX_CHARS[a>>8&15]+HEX_CHARS[a>>4&15]+HEX_CHARS[15&a]),H},Sha256.prototype.toString=Sha256.prototype.hex,Sha256.prototype.digest=function(){this.finalize();var t=this.h0,h=this.h1,r=this.h2,e=this.h3,s=this.h4,i=this.h5,o=this.h6,a=this.h7,H=[t>>24&255,t>>16&255,t>>8&255,255&t,h>>24&255,h>>16&255,h>>8&255,255&h,r>>24&255,r>>16&255,r>>8&255,255&r,e>>24&255,e>>16&255,e>>8&255,255&e,s>>24&255,s>>16&255,s>>8&255,255&s,i>>24&255,i>>16&255,i>>8&255,255&i,o>>24&255,o>>16&255,o>>8&255,255&o];return this.is224||H.push(a>>24&255,a>>16&255,a>>8&255,255&a),H},Sha256.prototype.array=Sha256.prototype.digest,Sha256.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),h=new DataView(t);return h.setUint32(0,this.h0),h.setUint32(4,this.h1),h.setUint32(8,this.h2),h.setUint32(12,this.h3),h.setUint32(16,this.h4),h.setUint32(20,this.h5),h.setUint32(24,this.h6),this.is224||h.setUint32(28,this.h7),t},HmacSha256.prototype=new Sha256,HmacSha256.prototype.finalize=function(){if(Sha256.prototype.finalize.call(this),this.inner){this.inner=!1;var t=this.array();Sha256.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(t),Sha256.prototype.finalize.call(this)}};var exports=createMethod();exports.sha256=exports,exports.sha224=createMethod(!0),exports.sha256.hmac=createHmacMethod(),exports.sha224.hmac=createHmacMethod(!0),COMMON_JS?module.exports=exports:(root.sha256=exports.sha256,root.sha224=exports.sha224,AMD&&define((function(){return exports})))})();

function l(v) { console.log(v); }

/* Shopify */
window.Shopify = window.Shopify || {};
window.Shopify.money_format = "${{amount_no_decimals}}";
window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

class WAL_Apploader {

    static events = {};

    constructor() {}

    static register(dependency, callback = () => {}) {
        if(WAL_Apploader.events[dependency] === true) {
            callback();
            return;
        }

        if(typeof WAL_Apploader.events[dependency] == 'undefined') {
            WAL_Apploader.events[dependency] = [];
        }
        WAL_Apploader.events[dependency].push(callback);
    }

    static on_ready(dependency) {
        WAL_Apploader.events[dependency].forEach(cb => cb());
        WAL_Apploader.events[dependency] = true;
    }

}

class WAL {

    constructor() {
        window._WAL = window._WAL || { Global: WAL };
    }

    init() {
        if (this && typeof window._WAL[this.constructor.name] == 'undefined' && this.#class_should_init() && this.should_init()) {

            WAL_Apploader.register(this.constructor.name);
            window.addEventListener('DOMContentLoaded', (e) => {
                this.config = { ...window._WAL_CONFIG, ...this.config };
                this.cache_dom();
                this.load();
                this.bind();
                this.loaded();

                window._WAL[this.constructor.name] = this;
                this.ready();
                //console.info(`Initialised: ${this.constructor.name}`);
            });

            window.addEventListener('shopify:section:load', e => this.reinit());

            // For LOCAL DEV ===========================
            if(window.location.hostname.includes('127.0.0.1')) {
                const observer = new MutationObserver((mutations) => {
                    for (const mutation of mutations) {
                        for (const node of mutation.addedNodes) {
                            node.nodeType === 1 && node.id && node.id.startsWith('shopify-section-') && this.reinit();
                        }
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }
            // =========================================
        }
    }

    reinit() {
        console.log(`Reinitialising: ${this.constructor.name}`);
        
        this.unbind();
        this.cache_dom();
        this.load();
        this.bind();
        this.loaded();
    }

    dom = {};

    config = {};

    cache = {};

    load() { }

    loaded() { }

    bind() { }

    unbind() { }

    ready() { WAL_Apploader.on_ready(this.constructor.name); }

    log(x = null) { console.log('%c' + x, 'color: #00AC9D; font-size: 14px;'); }

    log_html(config = {}) {
        // Logger via iframe srcdoc
        const c = {...{
            width: 300,
            height: 150,
            html: '',            
        }, ...config};
        document.getElementById('iframe-debugger')?.remove();
        document.body.insertAdjacentHTML('beforeend', `<iframe id="iframe-debugger"
            style="position: fixed; bottom: 10px; right: 10px; width: ${c.width}px; height: ${c.height}px; border: none; padding: 0 10px; background: #efefef; z-index: 9999; border-radius: 5px; box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.25);"
            srcdoc="${c.html}"
        ></iframe>`);
    }

    should_init() { return true; }

    #class_should_init() {
        if (this.constructor.name.startsWith('Site')) { return true; }
        if (this.constructor.name.startsWith('Prod') && !location.href.includes('/products/')) { return false; }
        if (this.constructor.name.startsWith('Col') && (!location.href.includes('/collections/') || location.href.includes('/products/'))) { return false; }
        if (this.constructor.name.startsWith('Page') && !location.href.includes('/pages/')) { return false; }

        return true;
    }

    cache_dom() {
        if (typeof jQuery == 'undefined') { return; }

        $.each(this.dom, (k, v) => {
            if (typeof v == 'function' || k.includes('$')) { return true; }
            if (typeof this.dom.container != 'undefined' && k[0] == '_') {
                k = k.replace('_', '');
                v = this.dom.container + ' ' + v.replaceAll(',', ','+this.dom.container);
            }
            this.dom['$' + k] = $(v);
        });
    }

    url = {
        get_path: (index = null) => {
            const path = location.pathname.replace((Shopify.routes.root || '/'), '/').substring(1).split('/');
            return index === null ? path : path[index];
        },
        get_param: (key = '') => {
            return (new URLSearchParams(window.location.search)).get(key) || '';
        },
    };

    aws = {

        base_url: 'https://wearelikewise-main.s3.ap-southeast-2.amazonaws.com',
        url: (path = '') => {
            if (typeof path == 'object') { path = path.join('/'); }
            if (path[0] != '/' && !path.includes(this.aws.base_url)) { path = '/' + path }
            if (!path.includes(this.aws.base_url)) { path = this.aws.base_url + path }

            return path;
        },
        has: (path) => {

            this.cache.aws__loading_img = this.cache.aws__loading_img || {};
            this.cache.aws__failed_img = this.cache.aws__failed_img || [];
            this.cache.aws__success_img = this.cache.aws__success_img || [];

            path = this.aws.url(path);

            if( this.cache.aws__failed_img.includes(path) ) {
                return new Promise((resolve, reject) => { reject(path); });
            } else if(this.cache.aws__success_img.includes(path)) {
                //return Promise.resolve(path);
                return new Promise((resolve, reject) => { resolve(path); });
            } else if(this.cache.aws__loading_img[path]) {
                return this.cache.aws__loading_img[path];
            } else {
                this.cache.aws__loading_img[path] = fetch(path, { cache: "no-cache" })
                .then((r) => {
                    if (r.status >= 200 && r.status < 300) {
                        !this.cache.aws__success_img.includes(path) && this.cache.aws__success_img.push(path);
                        return Promise.resolve(path);
                    } else {
                        !this.cache.aws__failed_img.includes(path) && this.cache.aws__failed_img.push(path);
                        return Promise.reject(path);
                    }
                })
                .catch((err) => {
                    const cache_result_timeout = 15000;
                    !this.cache.aws__failed_img.includes(path) && this.cache.aws__failed_img.push(path);
                    setTimeout(() => {
                        this.cache.aws__failed_img = this.cache.aws__failed_img.filter(url => url != path);
                    }, cache_result_timeout); // Remove after 15 secs to allow for retry
                    return Promise.reject(path);
                })
                .finally(() => {
                    delete this.cache.aws__loading_img[path];
                });
                return this.cache.aws__loading_img[path];
            }
        },

        lightsail: 'https://apps.wearelikewise.com',

    };

    helper = {
        img: {
            load: (img, url) => {
                const $img = $(img);
                $img.attr('src') != url && $img.attr('src', url).attr('srcset', '');
            }
        }
    };

    get is_in_design_mode() {
        return document.documentElement.classList.contains('shopify-design-mode');
    }

    get current_store() {
        if (typeof this.cache.current_store !== 'undefined') { return this.cache.current_store; }

        let domain_segments = window.location.host.split('.');
        let country_code = 'int';

        if (domain_segments[0].indexOf('we-are-likewise') > -1) {
            country_code = domain_segments[0].replace('we-are-likewise-', '');
        }

        if (domain_segments[0].length == 2 || domain_segments[0] == 'dev') {
            country_code = domain_segments[0];
        }

        this.cache.current_store = country_code;
        return this.cache.current_store;
    }

    get current_product() {
        if (this.cache.current_product) {
            return this.cache.current_product;
        }

        let p = this.config.product;
        p.options_with_values = p.options.map((opt, index) => {
            return {
                name: opt,
                values: [...new Set(p.variants.map(v => v.options[index]))],
            };
        });

        this.cache.current_product = p;
        return this.cache.current_product;
    }

    find_variant(name = '', scope = []) {
        scope = typeof scope != 'object' ? this.all : scope;
        scope = Array.isArray(scope) ? scope : [scope];
        let item = null;

        scope.forEach((p) => {
            if (typeof p == 'undefined' || p == null || Object.keys(p).length == 0) { return; }

            if (p.title == name) {
                item = p;
            } else {
                (p.variants || []).forEach((v) => {
                    if (v.public_title == name || v.id == name || v.title == name || v.sku == name) {
                        item = v;
                        item.product = p;
                    }
                });
            }
        });
        return item;
    }

    layout(data = []) {
        let html = '';
        data.forEach((row) => {
            let r = '';
            row.forEach((col) => {
                r += `<div class="col">${col}</div>`;
            });
            html += `<div class="row mb-3">${r}</div>`;
        });

        return `<div class="container">${html}</div>`;
    }

    compile_html(template = '', data = {}) {
        for (const [key, val] of Object.entries(data)) {
            template = template.replaceAll(`[[ ${key} ]]`, val);
        }
        return template;
    }

} new WAL();

class SiteStoreSelect extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {
        container: '#store-selector',
        _select_trigger: '[data-store-select-trigger]',
        _select_options: '[data-store-id]',

        trigger: '.shopify-section.section-header .header__store',
    };

    config = {
        stores: {
            // id: [shopify_domain, public_domain, auto_redirect]
            au: ['we-are-likewise-au.myshopify.com', 'au.wearelikewise.com', true],
            nz: ['we-are-likewise-nz.myshopify.com', 'nz.wearelikewise.com', false], // Ignore
            jp: ['we-are-likewise-jp.myshopify.com', 'jp.wearelikewise.com', true],
            us: ['we-are-likewise-us.myshopify.com', 'us.wearelikewise.com', true],
            ca: ['we-are-likewise-ca.myshopify.com', 'ca.wearelikewise.com', true],
            uk: ['we-are-likewise-uk.myshopify.com', 'uk.wearelikewise.com', true],
            gb: ['we-are-likewise-uk.myshopify.com', 'uk.wearelikewise.com', true], // same as UK
            eu: ['we-are-likewise-eu.myshopify.com', 'eu.wearelikewise.com', true],
            int: ['we-are-likewise-int.myshopify.com', 'wearelikewise.com', true],
        },
    };

    should_init() {
        return document.querySelector(this.dom.container) !== null;
    }

    load() {

        if (
            window.location.host.includes('.shopifypreview.com')
            || window.location.host.includes('.myshopify.com')
            || window.location.host.includes('dev.')
            || window.location.host.includes('127.0.0.1')
            || (Shopify?.theme?.role == "unpublished" && window.location.hash != "#preview")
        ) { return; }

        fetch('https://api.ipify.org')
            .then(r => r.text())
            .then((ip) => {

                fetch(`https://pro.ip-api.com/json/${ip}?key=4l32MhXEAUwEn6V`)
                    .then(r => r.json())
                    .then(ip_info => {
                        this.config.ip_info = ip_info;
                        this.redirect();
                    });

            });

    }

    bind() {

        this.dom.$trigger.on('click', this.toggle_store_selector.bind(this));

        this.dom.$select_options.on('click', (e) => { this.select_store(e.target.dataset.storeId); });

        this.dom.$select_trigger.on('click', (e) => {

            let subdomain = e.target.dataset.storeSelectTrigger === 'int' ? '' : e.target.dataset.storeSelectTrigger + '.';
            let new_url = window.location.href.replace(window.location.host, subdomain + 'wearelikewise.com');

            if (window.location.href == new_url) {

                this.toggle_store_selector(false);

            } else {

                window.location.href = new_url;

            }

        });

    }

    redirect() {

        let recommended_store = this.config.stores.int;
        let detected_store = this.config.ip_info.countryCode.toLowerCase();

        if (typeof this.config.stores[detected_store] !== 'undefined') {

            recommended_store = this.config.stores[detected_store];

        } else if (this.config.ip_info.timezone.split('/').shift() == 'Europe') {

            recommended_store = this.config.stores.eu;
            detected_store = 'eu';

        }

        if (!recommended_store.includes(window.location.host)) {

            if (!Cookies.get('recommended-store')) { // Auto redirect

                let now = new Date();

                Cookies.set('recommended-store', detected_store, {
                    expires: now.setDate(now.getDate() + 1),
                    domain: '.wearelikewise.com'
                });

                recommended_store[2] && window.location.replace('//' + recommended_store[1] + window.location.pathname);

            } else { // Show store selector

                this.select_store(Cookies.get('recommended-store'));
                this.toggle_store_selector(true);

            }

        }

    }

    toggle_store_selector(display) {
        if (display === true) { display = 'Down' }
        else if (display === false) { display = 'Up' }
        else { display = 'Toggle' }

        const cb = () => { $('html').trigger('header:resized'); };
        this.dom.$container[`slide${display}`]({
            progress: cb,
            complete: cb,
        });
    }

    select_store(id = '') {
        let selected_store = this.dom.$select_options.filter(`[data-store-id="${id}"]`);

        selected_store.addClass('d-none');
        this.dom.$select_options.filter('.d-none').not(selected_store).removeClass('d-none');

        this.dom.$container.find('.dropdown-toggle').html(selected_store.html());

        this.dom.$select_trigger.attr('data-store-select-trigger', id);
    }

} new SiteStoreSelect();

class SiteCart extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: 'cart-drawer',
        _line_items: 'table .cart-item',
        _input_qty: 'quantity-input .quantity__input',
        _remove_btn: 'cart-remove-button button',
        _clear_all: '[data-el="cart--clear"]',
        _line_item_warning: '[data-el="cart--line-item-flag-warning"][data-target-key]',
        _row_view_anchor: '[data-el="scroll-view-anchor"]',
        _error: '[data-el="cart-error"]',

        header: '.shopify-section.section-header',
        header_icon_count: '.header__icon--cart',

        _cart_share: '[data-el="product-configurator--share"]',

        tandc: '#terms-checkbox',
        ignore_free_products: '#ignore-free-product-checkbox',

    };

    config = {
        header_hidden_class: 'shopify-section-header-hidden',
        loading_icon: `<div class="spinner-grow" style="width: 13px; height: 13px; margin: -1.05px;" role="status"><span class="sr-only"></span></div>`,
        free_products_cart_attribute: 'Free Products',
    };

    cache = {
        ignore_free_products: false,
    };

    load() {
        this.config.sections = this.dom.$container[0]?.getSectionsToRender().map((section) => section.id).concat('cart').join(',');
    }

    bind() {

        this.dom.$container.on('click', this.dom._clear_all, (e) => {
            fetch('/cart/clear').then(() => { location.reload(); });
        });

        this.dom.$container.on('click', this.dom._line_item_warning, (e) => {
            const $this = $(e.target).closest(this.dom._line_item_warning);
            const $target = $(`[data-key="${$this.data('target-key')}"]`);
            $target.find(this.dom._row_view_anchor).get(0).scrollIntoView({behavior: "smooth"});
            $target.addClass('highlight');
            setTimeout(() => { $target.removeClass('highlight'); }, 3000);
        });

        this.dom.$container.on('change', this.dom.tandc, (e) => {
            this.dom.$tandc = $(this.dom.tandc);
            this.dom.$container.find('button[type="submit"][name="checkout"]').prop('disabled', !this.dom.$tandc.is(':checked'));
        });

        this.dom.$container.on('change', this.dom.ignore_free_products, (e) => {
            e.stopImmediatePropagation();
            this.set_form_loading_state();
            this.dom.$ignore_free_products.is(':checked') && this.func.update_attr({
                [ this.config.free_products_cart_attribute ]: ''
            }, res => {
                this.func.update_ui(res);
                this.reinit();
                this.dom.$container[0].open();
                this.scroll_to_bottom();
            });
        });
        
        this.dom.$container.on('change keyup', this.dom._input_qty, (e) => {
            let $this = $(e.target);
            let $container = $this.closest(this.dom._line_items);

            // EXIT IF NOT A MAIN PRODUCT
            if (!$container.data('group').includes('#')) { return; }

            const group_id = $container.data('group').replace(/\D/g, '');

            $container.siblings(`[data-group*="${group_id}"]`).each((k, el) => {
                $(el).find(this.dom._input_qty).val($this.val());
            });
        });

        this.dom.$container.on('click', this.dom._remove_btn, (e) => {
            let items = {};
            let $this = $(e.target);
            let $container = $this.closest(this.dom._line_items);

            // SET CLICKED PRODUCT
            items[$container.data('key')] = 0;

            // IF MAIN PRODUCT
            if ($container.data('group').includes('#')) {
                const group_id = $container.data('group').replace(/\D/g, '');

                $container.find(this.dom._input_qty).val(0);
                $container.siblings(`[data-group*="${group_id}"]`).each((k, el) => {
                    let $this = $(el);
                    $this.find(this.dom._input_qty).val(0);
                    items[$this.data('key')] = 0;
                });
            }

            // IF OPTIONAL PRODUCT
            if (!$container.data('group').includes('#') && !$container.data('group').includes('*')) {
                const group_id = $container.data('group').replace(/\D/g, '');
                const this_sku = $container.data('prod-sku');

                // Ignore if SKU is not set
                $container.find(this.dom._input_qty).val(0);
                this_sku?.length && $container.siblings(`[data-group*="${group_id}"][data-prod-prerequisite*="${this_sku}"]`).each((k, el) => {
                    let $this = $(el);
                    $this.find(this.dom._input_qty).val(0);
                    items[$this.data('key')] = 0;
                });
            }

            this.func.update(items);
        });

        this.dom.$container.on('click', 'button[type="submit"][name="update"]', (e) => {
            const $this = $(e.currentTarget);
            $('#'+$this.attr('form')).attr('reload', true)
        });

        this.dom.$container.on('submit', 'form', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);

            this.dom.$container.find('button[type="submit"]').prop('disabled', true).html(this.config.loading_icon);
            let items = {};
            this.dom.$container.find(this.dom._line_items).each((k, el) => {
                let $this = $(el);
                items[$this.data('key')] = $this.find(this.dom._input_qty).val();
            });

            this.func.update(items, () => {
                if( $this.is('[reload]') ) {
                    this.func.reload();
                } else {
                    // REQUIRED --> Condition to enforce before checkout
                    //if(!_WAL.SiteCartUpsell.is_ready_for_checkout() && this.cache.cart.attributes[ this.config.free_products_cart_attribute ] != this.config.lang.cart.free_products_validation.ignore) {
                    // OPTIONAL --> Condition to suggest before checkout
                    if(!_WAL.SiteCartUpsell.is_ready_for_checkout() && !this.cache.ignore_free_products) {
                        return this.prompt__add_free_products(e);

                    // OPTIONAL
                    } else if( typeof this.cache.cart.attributes[ this.config.lang.cart.shopping_for ] == 'undefined' ) {
                        return this.prompt__add_car(e);

                    // DEFAULT
                    } else {
                        window.location.href = '/checkout';
                    }
                }
            });

            return false;
        });

        // SHARE
        this.dom.$container.on('click', this.dom._cart_share, (e) => {

            e.preventDefault();

            _WAL.SiteGlobal.modal('slide', {

                //large: true,
                title: this.config.lang.share.title,
                description: this.config.lang.share.description,
                action: this.config.lang.share.action,
                body: `
                    <input type="email" class="field__input font-helvetica" value="${this.config.customer.email || ''}" />
                    <label class="field__label font-helvetica">Email</label>
                `,
                action_callback: ($modal) => {

                    fetch('/cart.json').then(r=>r.json()).then((res) => {
                        const items = res.items.map(i => ({
                            id: i.variant_id,
                            quantity: i.quantity,
                            properties: i.properties,
                        }));

                        return $.post({

                            url: this.aws.lightsail+'/api/product-share',
                            dataType: 'json',
                            data: {
                                e_to: $modal.find('input[type="email"]').val(),
                                e_title: this.config.lang.email.share_email_subject,                            
                                
                                cart_endpoint: window.location.origin+'/cart/add.js',
                                cart_email_layout: window.location.origin+'/cart?view=email-layout',
                                json_cart: JSON.stringify({ items: items }),
                            }

                        }).then((res) => {
                            _WAL.SiteGlobal.modal('slide', {
                                title: this.config.lang.share.actioned,
                                description: res.message,
                            });
                        })
                        .fail((res) => {   
                            _WAL.SiteGlobal.modal('slide', {
                                title: '<span class="text-danger">Error</span>',
                                description: JSON.parse(res.responseText).message,
                            })
                        });
                        
                    })

                },

            });

        });

    }

    scroll_to_bottom() {
        this.dom.$container.find('cart-drawer-items').get(0).scrollTo(0, this.dom.$container.find('cart-drawer-items').get(0).scrollHeight);
    }

    set_form_loading_state(is_loading = true) {
        const $btn_submit = this.dom.$container.find('button[type="submit"]');
        $btn_submit.prop('disabled', is_loading).html(is_loading ? this.config.loading_icon : $btn_submit.data('default-text'));

        const $btn_update = this.dom.$container.find('button[type="update"]');
        $btn_update.prop('disabled', is_loading).html(is_loading ? this.config.loading_icon : $btn_update.data('default-text'));
    }

    prompt__add_car(e) {
        this.dom.$container.get(0).close();
        this.func.reload();

        _WAL.SiteGlobal.modal('popup', {
            title: this.config.lang.product_compatibility.heading,
            body: this.config.lang.product_compatibility.checkout_warning,
            action: this.config.lang.product_compatibility.add,
            action_callback: ($modal) => {
                $modal.modal('hide');
                document.querySelector('#ProductCompatibilityModal').show();
            },
            action_secondary: this.config.lang.cart.continue_checkout,
            action_secondary_callback: ($modal) => {
                $modal.modal('hide');
                window.location.href = '/checkout';
            }
        });
    }

    prompt__add_free_products(e) {
        const $view = this.dom.$container;
        $view.get(0).close();
        this.func.reload();

        _WAL.SiteGlobal.modal('popup', {
            title: this.config.lang.cart.free_products_validation.heading,
            body: this.config.lang.cart.free_products_validation.message,
            action: this.config.lang.cart.free_products_validation.action,
            action_callback: ($modal) => {
                $modal.modal('hide');
                $view.get(0).open();
                this.scroll_to_bottom();
            },
            action_secondary: this.config.lang.cart.free_products_validation.ignore,
            action_secondary_callback: ($modal) => {
                $modal.modal('hide');
                this.cache.ignore_free_products = true;
                this.dom.$container.find('form').trigger('submit');
                return;

                // Capture user choice to ignore free products
                this.func.update_attr(
                    { [ this.config.free_products_cart_attribute ]: this.config.lang.cart.free_products_validation.ignore },
                    res => {
                        this.func.update_ui(res);
                        this.reinit();
                        this.dom.$container.find('form').trigger('submit');
                    }
                );
            }
        });
    }

    loaded() {

        if(window.location.hash == '#cart') {
            setTimeout(() => this.dom.$container.get(0).open(), 2000);
        }
        
        !this.cache.cart && this.func.reload();
    }

    func = {

        __pre_request: () => {
            this.dom.$container.find(this.dom._error).text('');
        },

        __err_handler: (jqXHR, textStatus, errorThrown) => {
            //console.error('Error updating cart', jqXHR, textStatus, errorThrown);
            // console.error(jqXHR.responseJSON.message);
            this.dom.$container.find(this.dom._error).text(jqXHR.responseJSON.message);
            this.set_form_loading_state(false);
        },

        reload: (cb) => {
            delete this.cache.silent_update; // do nothing
            return $.ajax({
                method: 'get',
                url: '/cart',
                data: { sections: this.config.sections },
                success: (res) => {
                    this.func.update_ui({ sections: res });
                    cb && cb();
                }
            });
        },

        add: (items, cb = null, err = null, done = null) => {
            this.func.__pre_request();

            this.cache.silent_update = false;
            return $.ajax({
                method: 'post',
                url: '/cart/add.js',
                data: { items: items, sections: this.config.sections },
                dataType: 'json',
                success: cb || this.func.update_ui,
                error: err || this.func.__err_handler,
                complete: done
            });
        },

        update: (items, cb = null, err = null, done = null) => {
            this.func.__pre_request();

            delete this.cache.silent_update; // do nothing
            return $.ajax({
                method: 'post',
                url: '/cart/update.js',
                data: { updates: items, sections: this.config.sections },
                dataType: 'json',
                success: cb || this.func.update_ui,
                error: err || this.func.__err_handler,
                complete: done
            });
        },

        change: (items, cb = null, err = null, done = null) => {
            this.func.__pre_request();

            delete this.cache.silent_update; // do nothing
            return $.ajax({
                method: 'post',
                url: '/cart/change.js',
                data: { ...items, ...{sections: this.config.sections} },
                dataType: 'json',
                success: cb || this.func.update_ui,
                error: err || this.func.__err_handler,
                complete: done
            });
        },
        
        update_attr: (attr, cb) => {
            this.cache.silent_update = true;
            return $.ajax({
                method: 'post',
                url: '/cart/update.js',
                data: { attributes: attr, sections: this.config.sections },
                dataType: 'json',
                success: cb ? cb : this.func.update_ui,
            });
        },

        update_ui: (res) => {

            if(typeof res.sections == 'string') {
                res.sections = JSON.parse(res.sections);
            }

            if(res.sections.cart) {
                this.cache.cart = JSON.parse($(res.sections.cart).html());

                if(this.cache.cart.item_count == 0) {
                    this.dom.$container.get(0).close();
                }

                this.dom.$header.removeClass(this.config.header_hidden_class);
                this.dom.$header_icon_count.toggleClass('d-none', this.cache.cart.item_count == 0);
                this.dom.$container.toggleClass('is-empty', this.cache.cart.item_count == 0);

            }

            this.dom.$container[0].renderContents(res);
            
            if(this.cache.silent_update === true) {
                this.dom.$container[0].close();
            } else if (this.cache.silent_update === false) {
                this.dom.$container[0].open();
            }

            _WAL.SiteCartUpsell.reinit();
        },

    };

} new SiteCart();

class SiteCartUpsell extends WAL {

  constructor() {
    super();
    this.init();
  }

  config = {
    loading_icon: `<div class="spinner-grow" style="width: 13px; height: 13px; margin: -1.05px;" role="status"><span class="sr-only"></span></div>`
  };

  cache = {
  	selected_vars: {},
    products: {},
  };

  dom = {
    outter_container: 'cart-drawer',
    cart_form: 'cart-drawer form[action="/cart"]',

    container: '[data-el="shopify-section-cart--upsell"], [data-el="shopify-section-cart--banner"]',
    _before_half: '[data-label-before-half]',
    _after_half: '[data-label-after-half]',
    _after_limit: '[data-label-after-limit]',

    free_items: '[data-el="shopify-section-cart--upsell"]',
    prevent_checkout: '[data-prevent-checkout]',
  };

  load() {

    this.toggle_msg();

    // set product
    this.dom.$container.each((k, el) => {
        const $container = $(el);
        const json_src = $container.find('script[type="application/json"]');
        
        if (json_src.length == 0 ) { return; }
        const prod = JSON.parse( json_src[0].innerHTML );
        this.cache.products[prod.handle] = prod;

        if(this.cache.products[prod.handle].variants.length == 1) {
            $container.find('select').hide();
            this.cache.selected_vars[prod.handle] = this.cache.products[prod.handle].variants[0];

            // AUTO ADD - single in-stock variant, nothing to choose
            $container.is('[data-auto-add][data-is-free]') && this.cache.selected_vars[prod.handle].available && this.auto_add_upsell($container, prod.handle);
        }

        if(
            (!this.cache.products[prod.handle] && !this.cache.products[prod.handle].featured_image && !this.cache.products[prod.handle].featured_image.src) &&
            (!this.cache.selected_vars[prod.handle] && !this.cache.selected_vars[prod.handle].featured_image && !this.cache.selected_vars[prod.handle].featured_image.src)
        ) {
            $container.find('img').hide();
        }

    });

  }

  auto_add_upsell($container, productHandle) {
    // Only one add in flight; the cart reload re-runs load() for any remaining blocks
    if (this.is_auto_adding) { return; }

    // Only auto add once per cart per product/limit, so a customer removing it isn't overridden
    // A new cart token (e.g. after checkout) resets the list
    const token = $container.data('cart-token');
    const key = productHandle + ':' + $container.data('min-limit');
    let added = {};
    try { added = JSON.parse(sessionStorage.getItem('CART--auto-free-product')) || {}; } catch (e) {}
    if (added.token != token) { added = { token: token, keys: [] }; }
    if (added.keys.includes(key)) { return; }

    added.keys.push(key);
    try { sessionStorage.setItem('CART--auto-free-product', JSON.stringify(added)); } catch (e) {}

    this.is_auto_adding = true;
    $container.find('button[type="submit"][name="update"]').prop('disabled', true).html(this.config.loading_icon);

    this.add_upsell($container, productHandle).always(() => {
        this.is_auto_adding = false;
    });
  }

  add_upsell($container, productHandle) {
    const random_group_id = (Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)).toString();

    let prop = { '_group': '#'+random_group_id};

    if ($container.is('[data-is-free]')) {

        prop._free = this.cache.products[productHandle].handle;
        prop._free_from = $container.data('min-limit');

    }

    return _WAL.SiteCart.func.add([
        {
            id: this.cache.selected_vars[productHandle].id,
            quantity: 1,
            properties: prop
        }
    ], () => { /* do nothing after update */ })
    .then(() => {
        return _WAL.SiteCart.func.update_attr({
            [ _WAL.SiteCart.config.free_products_cart_attribute ]: ''
        }, _WAL.SiteCart.func.reload);
    });
  }

  is_ready_for_checkout() {
    return this.dom.$outter_container.find(this.dom.free_items + this.dom.prevent_checkout).length == 0;
  }

  bind() {

    this.dom.$outter_container.on('touchstart focus', this.dom.container+' select', this.event.focus__opt);
    this.dom.$outter_container.on('change', this.dom.container+' select', this.event.change__opt_change);
    this.dom.$outter_container.on('click', 'button[type="submit"][name="update"]', this.event.submit__set_upsell);
  }
  unbind() {
    this.cache.selected_vars = {}; // IMPORTANT - Clear all selected variants
    this.cache.products = {}; // IMPORTANT - Clear all products
    this.dom.$outter_container.off('touchstart focus', this.event.focus__opt);
    this.dom.$outter_container.off('change', this.event.change__opt_change);
    this.dom.$outter_container.off('click', this.event.submit__set_upsell);
  }

  event = {

    focus__opt: (e) => {

      let $this = $(e.target);
      const $container = $this.closest(this.dom.container);
      const $selects = $container.find('select');
      const productHandle = $container.data('product');
      
      if (!productHandle || !this.cache.products[productHandle]) return;

      if(!$this.is('select') || $this.is($selects.eq(0))) { return; }

      let opt1 = $selects.eq(0).val();
      if ($selects.eq(0).length && opt1 == '') {
        opt1 = $selects.eq(0).data('options')[0];
      }
      let opt2 = $selects.eq(1).val();
      if ($selects.eq(1).length && opt2 == '') {
        opt2 = $selects.eq(1).data('options')[0];
      }
      let opt3 = $selects.eq(2).val();
      if ($selects.eq(2).length && opt3 == '') {
        opt3 = $selects.eq(2).data('options')[0];
      }
      //console.log(opt1, opt2, opt3);
      
      $selects.each((key, val) => {

        let $s = $(val);

        if ($s.index() < $this.index()) { return true; }

        const current_val = $s.val();
        $s.find('option:not([value=""])').remove();

        $s.data('options').forEach((v, k) => {

          let variant = null;
          let opt_id = '';
          v = $('<textarea />').html(v).text();

          if ($s.is($this) && key == 0) {
            opt_id = [v, opt2, opt3].join(' / ').replace(/ \/ +$/, '');
            variant = this.find_variant(opt_id, this.cache.products[productHandle]);
          } else if ($s.is($this) && key == 1) {
            opt_id = [opt1, v, opt3].join(' / ').replace(/ \/ +$/, '');
            variant = this.find_variant(opt_id, this.cache.products[productHandle]);
          } else if ($s.is($this) && key == 2) {
            opt_id = [opt1, opt2, v].join(' / ').replace(/ \/ +$/, '');
            variant = this.find_variant(opt_id, this.cache.products[productHandle]);
          }

          if (variant != null ) {
            let attr = variant.available ? '' : 'disabled';
            v == current_val && (attr += ' selected');
            const txt = variant.available ? v : `${v} - ${this.config.lang.product.sold_out}`;
            $s.append(`<option ${attr} value="${v}">${txt}</option>`);
          }

        });

      });

    },

    change__opt_change: (e) => {

      let $this = $(e.target);
      const $container = $this.closest(this.dom.container);
      const $selects = $container.find('select');
      const $img = $container.find('img');
      const productHandle = $container.data('product');
      
      if (!productHandle || !this.cache.products[productHandle]) return;

      let opt1 = $selects.eq(0).val();
      if ($selects.eq(0).length && opt1 == '') {
        opt1 = $selects.eq(0).data('options')[0];
      }
      let opt2 = $selects.eq(1).val();
      if ($selects.eq(1).length && opt2 == '') {
        opt2 = $selects.eq(1).data('options')[0];
      }
      let opt3 = $selects.eq(2).val();
      if ($selects.eq(2).length && opt3 == '') {
        opt3 = $selects.eq(2).data('options')[0];
      }

      //$this.nextAll('select').val('');
      $this.nextAll('select').find('option:first-child').prop('selected', true);

      const $first_select = $selects.eq(0);
      const selected_prod = {
        variants: this.cache.products[productHandle].variants.filter((v) => {
          return v.options[0] == $first_select.val();
        })
      };
      
      this.cache.selected_vars[productHandle] = this.find_variant([opt1, opt2, opt3].join(' / ').replace(/ \/ +$/, ''), this.cache.products[productHandle]) || this.cache.products[productHandle].variants.filter(v => v.id == $container.find('select').val())[0];

      // SUBMIT BTN UPDATE
      $container.find('button[type="submit"][name="update"]').prop('disabled', this.cache.selected_vars[productHandle]?.available == false ? true : false);

      // IMG UPDATE
      if (this.cache.selected_vars[productHandle] && typeof this.cache.selected_vars[productHandle] == 'object' && typeof this.cache.selected_vars[productHandle].length == 'undefined') {

        if(!this.cache.selected_vars[productHandle].featured_image || !this.cache.selected_vars[productHandle].featured_image.src) {
          return;
        }

        let img_src = this.cache.selected_vars[productHandle].featured_image.src.split('?')[0]+'?width=500';
        this.helper.img.load( $img, img_src );
        $img.css('opacity', this.cache.selected_vars[productHandle].available ? '1' : '0.3');

      } else if(selected_prod.variants.length) {

        let img_src = selected_prod.variants[0].featured_image.src.split('?')[0]+'?width=500';
        this.helper.img.load( $img, img_src );
        $img.css('opacity', '0.3');
        $selects.each((key, val) => {
          if (key == 0) { return; }
          $(val).find('option:first-child').prop('selected', true);
        });

      }

      $img.show();

    },

    submit__set_upsell: (e) => {

        let $this = $(e.target);
        let $container = $this.closest(this.dom.container);
        const productHandle = $container.data('product');
        
        if (!productHandle || !this.cache.products[productHandle]) return;
        if (!this.cache.selected_vars[productHandle] || !this.cache.selected_vars[productHandle].available) { return; }
        
        e.preventDefault();

        if (this.dom.$cart_form[0].reportValidity()) {

            this.dom.$outter_container.find('button[type="submit"]').each((k, btn) => {

                let $btn = $(btn);
                $btn.prop('disabled', true);
                $btn.css('width', $btn.outerWidth()+'px');

            });
            $this.html(this.config.loading_icon);

        } else {
            return false;
        }

        this.add_upsell($container, productHandle);

        return false;

    },

  }

  toggle_msg() {
    this.dom.$container.each((k, el) => {
        const $this = $(el);
        let cart_price = parseFloat($this.data('cart-price'));
        let min_price = parseFloat($this.data('min-limit'));
        if (cart_price < min_price) {
            $this.find(this.dom._before_half).show();
            if (cart_price > (min_price / 2)) {
                $this.find(this.dom._after_half).show();
            }
        } else {
            $this.find(this.dom._after_limit).show();
        }
    });
  }

} new SiteCartUpsell();

class SiteProdCompatibility extends WAL {

    constructor() {
        super();
        this.init();
    }

    config = {
        customer_car_list: 'SITE--customer-car-list',
        db_car_list: 'SITE--db-car-list',
        
        /* required from the global config -------
        fitment_page_handle: '',
        */
    };

    cache = {
        form_options: {},
        customer: {
            car: [],
        }
    };

    dom = {

        container: 'product-compatibility-modal',

        _action: '[data-action]',
        _input: 'input[name], select[name]',

        _form: '[data-view="form"]',
        _list: '[data-view="form"]',

        _form_make: 'select[name="make"]',
        _form_model: 'select[name="model"]',
        _form_year: 'select[name="year"]',
        _form_trans: 'select[name="transmission"]',

        _template: 'template',

        modal: '#ProductCompatibilityModal',

        submitButton: '#form-submit-button',
        addCarScreen: '.add-new-car',
        carListItemTemplate: 'template',
        carList: '.list-car',
        cardProduct: '#ProductGridContainer #product-grid .grid__item',

        header_icon: '.header__car-checker button',
        cart_info: '.cart-drawer__selected-car-info',

        section_ui: '.shopify-section.section--product-compatibility .product-compatibility',

    };

    load() {
    
        this.get_customer_metafields().then(() => {
            this.cache.customer = {
                car: JSON.parse(sessionStorage.getItem(this.config.customer_car_list)) || [],
            };

            if( !this.cache.customer.car.length ) {
                WAL_Apploader.register('SiteCart', () => {
                    window._WAL.SiteCart.func.update_attr({[this.config.lang.cart.shopping_for]: ''});
                });
            } else {
                WAL_Apploader.register('ProdConfig',  () => { _WAL.ProdConfig.preselect.bind(_WAL.ProdConfig)() });
            }
    
            this.render_car_list();
            this.update_ui();
        });

        this.cache.form_options_ready = this.load_form_options().then((data) => {
            Object.keys(this.cache.form_options).forEach((o) => {
                this.dom.$form_make.append(`<option value="${o}">${o}</option>`);
            });
        });
    }

    bind() {

        this.dom.$form_make.on('change', (e) => {
            this.dom.$form_model.find('option:not(:first-child)').remove();
            this.dom.$form_trans.find('option:not(:first-child)').remove();
            this.dom.$form_year.find('option:not(:first-child)').remove();

            this.dom.$form_model.find('option:first-child').prop('selected', true);
            this.dom.$form_trans.find('option:first-child').prop('selected', true);
            this.dom.$form_year.find('option:first-child').prop('selected', true);

            const $this = $(e.currentTarget);
            console.log(this.cache.form_options[$this.val()]);
            const data = Object.keys(this.cache.form_options[$this.val()]);
            data.forEach((o) => {
                this.dom.$form_model.append(`<option value="${o}">${o}</option>`);
            });

            if(data.length == 1) {
                this.dom.$form_model.find('option:nth-child(2)').prop('selected', true);
                this.dom.$form_model.trigger('change');
            }
        });

        this.dom.$form_model.on('change', (e) => {
            this.dom.$form_trans.find('option:not(:first-child)').remove();
            this.dom.$form_year.find('option:not(:first-child)').remove();

            this.dom.$form_trans.find('option:first-child').prop('selected', true);
            this.dom.$form_year.find('option:first-child').prop('selected', true);

            const $this = $(e.currentTarget);
            const data = Object.keys(this.cache.form_options[this.dom.$form_make.val()][$this.val()]);
            data.forEach((o) => {
                this.dom.$form_trans.append(`<option value="${o}">${o}</option>`);
            });
            
            if(data.length == 1) {
                this.dom.$form_trans.find('option:nth-child(2)').prop('selected', true);
                this.dom.$form_trans.trigger('change');
            }
        });

        this.dom.$form_trans.on('change', (e) => {
            this.dom.$form_year.find('option:not(:first-child)').remove();

            this.dom.$form_year.find('option:first-child').prop('selected', true);

            const $this = $(e.currentTarget);
            const data = Object.keys(this.cache.form_options[this.dom.$form_make.val()][this.dom.$form_model.val()][$this.val()]);
            data.forEach((o) => {
                this.dom.$form_year.append(`<option value="${o}">${o}</option>`);
            });

            if(data.length == 1) {
                this.dom.$form_year.find('option:nth-child(2)').prop('selected', true);
                this.dom.$form_year.trigger('change');
            }
        });

        WAL_Apploader.register('SiteGlobal',  () => {
            const cb = () => {
                this.dom.$section_ui.parent().css('--header-height', _WAL.SiteGlobal.calc_header('px'));
            };
            $('html').on('header:resized', cb).trigger('header:resized');
            $(window).on('resize', cb);
        });

        /* REMOVED by the client's request
        if(this.dom.$section_ui.length) {
            $(window)
            .on('resize', () => {
                this.dom.$section_ui.parent().css('height', this.dom.$section_ui.height()+'px');
            })
            .on('scroll', () => {
                this.dom.$section_ui.attr('data-desktop-position', this.dom.$section_ui.parent().isInViewport() ? 'static' : 'fixed');

            })
            .resize();
        } */

        document.body.addEventListener('MODAL-DIALOG--Opened', () => {
            if (this.cache.customer.car.length) {
                this.user_action.view();
            } else {
                (this.cache.form_options_ready || Promise.resolve()).then(() => {
                    this.config.blog.metafields.vehicle_detail && this.preset({
                        make: this.config.blog.metafields.vehicle_detail[0],
                        model: this.config.blog.metafields.vehicle_detail[1],
                        trans: this.config.blog.metafields.vehicle_detail[2],
                        year: this.config.blog.metafields.vehicle_detail[3],
                    });
                });
                this.user_action.add();
            }
        });

        // CLICKABLE BUTTONS
        this.dom.$container.on('click', this.dom._action, (e) => {
            e.preventDefault();
            let $this = $(e.currentTarget);
            this.user_action[$this.data('action')]($this.data('value'));
        });

        this.dom.$modal.on('modalClosed', (e) => {
            // return; // Autosave is currently disabled
            if(!this.cache.customer.car.length) {
                this.user_action.save();
            }
        });

    }

    reload() {
        this.dom.$header_icon.attr('data-car-count', this.cache.customer.car.length == 0 ? '?' : this.cache.customer.car.length);
    }

    load_form_options() {
        const sessionData = sessionStorage.getItem(this.config.db_car_list);

        if (typeof(sessionData) == 'undefined' || sessionData === null) {
            return fetch(this.config.primary_store+'/pages/'+this.config.fitment_page_handle).then(res => res.json()).then((res) => {
                let cars = {};
                res.forEach((row) => {
                    if (row.length > 0) {
                        const make = row[0];
                        const model = row[1];
                        const year = row[2];
                        const trans = row[3];

                        cars[make]                      = cars[make] || {};
                        cars[make][model]               = cars[make][model] || {};
                        cars[make][model][trans]        = cars[make][model][trans] || {};
                        cars[make][model][trans][year]  = (cars[make][model][trans][year] || []).concat(row.slice(4));
                        //cars[make][model][trans][year]  = [...new Set(cars[make][model][trans][year])]; // remove duplicates
                    }
                });
                this.cache.form_options = cars;
                sessionStorage.setItem(this.config.db_car_list, JSON.stringify(cars));
                return cars;
            });
        } else {
            this.cache.form_options = JSON.parse(sessionStorage.getItem(this.config.db_car_list));
            return Promise.resolve(this.cache.form_options);
        }
    }

    get_customer_metafields() {
        if (!this.config.customer?.id) {
            return Promise.resolve([]);
        }
        return fetch('/account?view=metafields')
            .then((response) => response.text())
            .then((res) => {
                try {
                    return res && sessionStorage.setItem(this.config.customer_car_list, res) && JSON.parse(res);
                } catch (e) { }
            });
    }

    get_current_car_label() {
        return this.cache?.customer?.car?.length && [
            this.cache.customer.car[0].make,
            this.cache.customer.car[0].model,
            this.cache.customer.car[0].transmission,
            '('+this.cache.customer.car[0].year+')'
        ].join(' ');
    }

    render_car_list() {
        this.dom.$header_icon.attr('data-car-count', this.cache.customer.car.length == 0 ? '?' : this.cache.customer.car.length);

        if (this.cache.customer.car.length == 0) {
            this.dom.$container.attr('data-view', 'form-new');
        } else {
            this.dom.$template.siblings().remove();
            let html = '';
            this.cache.customer.car.forEach((data, index) => {
                html += this.dom.$template.html()
                    .replaceAll('[[ ', '[[')
                    .replaceAll(' ]]', ']]')
                    .replaceAll('[[car.name]]', data.name == '' ? data.make + ' ' + data.model : data.name)
                    .replaceAll('[[car.make]]', data.make)
                    .replaceAll('[[car.model]]', data.model)
                    .replaceAll('[[car.year]]', data.year)
                    .replaceAll('[[car.transmission]]', data.transmission)
                    .replaceAll('[[index]]', index);
            });
            this.dom.$template.before(html);
        }
    }

    update_ui() {

        $('style#' + this.constructor.name).remove();

        this.get_compatible_prods(true).then((compatible_prods) => {

            let css = '';

            if (!compatible_prods.length) {

                $('[data-upgraded-fitment-table]').attr('data-row-focus', null);

                css = '.shopify-section.section--product-compatibility { display: block; }';

            } else {

                // FITMENT PAGE
                const car = this.cache.customer.car[0];
                //const $tr = $(`tr[data-make*="${car.make}"][data-model*="${car.model}"][data-trans*="${car.transmission}"][data-year*="${car.year}"]`);
                //$tr.siblings('.highlight').removeClass('highlight');
                //$tr.addClass('highlight');
                $('[data-upgraded-fitment-table]').attr('data-row-focus', '');

                css = `
                    .template-page--fitment .page-fitment--controls, .template-page--fitment table > tbody > tr:first-child { position: initial; }
                    tr[data-make*="${car.make}"][data-model*="${car.model}"][data-trans*="${car.transmission}"][data-year*="${car.year}"] { display: table-row !important; }

                    :root { --selected-car: '${car.name || car.model}'; }
                    #product-grid .grid__item:not([data-collections*="${this.config.generic_collection}"]) img { opacity: 0.5; }
                    /* .shopify-section.section--product-compatibility { display: none !important; } */

                    .product-card-wrapper [data-compatible=""],
                    [data-el="product-configurator--container"]:not([data-prod-collections*="${this.config.generic_collection}"]), 
                    [data-el="product-configurator--container"] [data-compatible=""] { display: none !important; }

                    .product-card-wrapper [data-compatible="false"],
                    [data-el="product-configurator--container"] [data-compatible="false"] { display: flex !important; }

                    .cart-item__details [data-compatible="false"] { display: inline-block !important; }
                `;
                compatible_prods.forEach((prod) => {
                    prod = prod.split('::');

                    css += `
                        .product-card-wrapper[data-compatible-prods*="${prod[0]}"] [data-compatible="false"] { display: none !important; }
                        
                        .product-card-wrapper[data-compatible-prods*="${prod[0]}"] [data-compatible="true"] { display: flex !important; }
                        .product-card-wrapper[data-compatible-prods*="${prod[0]}"] img { opacity: 1 !important; }

                        [data-el="product-configurator--container"][data-compatible-prods*="${prod[0]}"]:not(:first-child),
                        [data-el="product-configurator--container"][data-prod-handles*="${prod[0]}"] { display: flex !important; }
                        [data-el="product-configurator--container"][data-prod-handles*="${prod[0]}"] [data-compatible="false"] { display: none !important; }
                        [data-el="product-configurator--container"][data-prod-handles*="${prod[0]}"] [data-compatible="true"] { display: flex !important; }
                        [data-el="product-configurator--container"][data-prod-handles*="${prod[0]}"] img { opacity: 1 !important; }
                        [data-el="product-configurator--container"][data-compatible-prods*="${prod[0]}"] [data-compatible="false"] { display: none !important; }
                        [data-el="product-configurator--container"][data-compatible-prods*="${prod[0]}"] [data-compatible="true"] { display: flex !important; }
                        [data-el="product-configurator--container"][data-compatible-prods*="${prod[0]}"] img { opacity: 1 !important; }

                        .cart-item[data-prod-handles*="${prod[0]}"] .cart-item__details [data-compatible="false"] { display: none !important; }
                    `;

                    if(prod.length > 1) {
                        css += `
                            .cart-item[data-prod-handle="${prod[0]}"]:not([data-prod-var*="${prod[1].replaceAll('"', '\\"')}"]) .cart-item__details [data-compatible="false"] { display: inline-block !important; }
                        `;
                    }
                });

                // OVERRIDE
                css += `
                    [data-el="product-configurator--container"][data-must-display="true"],
                    [data-el="product-configurator--product-preview"] { display: flex !important; }
                    [data-el="product-configurator--container"][data-bundle-index-ui="#"] { display: none !important; }
                `;
            }

            $('head').append(`<style id="${this.constructor.name}">${css}</style>`);

        });

        $('html').trigger('header:resized');
    }

    get_compatible_prods(with_var = false) {

        if (this.cache.customer.car.length == 0) {
            return Promise.resolve([]);
        }

        return this.load_form_options().then(() => {

            let handles = [];
            const data = this.cache.customer.car[0];
            const prods = this.cache.form_options[data.make][data.model][data.transmission][data.year];

            if (prods) {
                prods.forEach((prod) => {
                    var div = document.createElement('div');
                    div.innerHTML = prod;
                    for (let item of div.getElementsByTagName('a')) {
                        const href = item.getAttribute('href');
                        let text = '';
                        if (item.nextSibling) text = item.nextSibling.nodeValue;
                        const productHandle = href.split('/').slice(-1)[0];
                        if (!handles.includes(productHandle)) {

                            div.getElementsByTagName('a')[0].remove();
                            let var_title = div.innerHTML.replace(/(<([^>]+)>).*(<([^>]+)>)/, '').trim().replaceAll('”', '"');
                            var_title = var_title.charAt(0) === '/' ? '::' + var_title.slice(1).trim() : var_title;
                            handles.push(productHandle + (!with_var ? '' : var_title));

                        }
                    }
                });
            }

            return handles;

        });

    }

    update_customer_vehicles() {

        if (!this.config.customer.id) {
            return Promise.resolve('');
        }

        return $.ajax({
            type: 'POST',
            url: this.aws.lightsail+'/api/my-cars',
            data: {
                store: this.current_store,
                customer_id: this.config.customer.id,
                vehicles: this.cache.customer.car,
            },
            dataType: 'json'
        }).catch((e) => { console.log(e); });

    }

    user_action = {

        view: () => {
            this.dom.$container.attr('data-view', 'list');
        },

        add: (val) => {
            this.dom.$container.attr('data-view', 'form-new');

            this.dom.$input.each((k, el) => {
                let $i = $(el);
                $i.find('option').length == 0 ? '' : $i.find('option:first-child').prop('selected', true);
                $i.removeClass('is-invalid');

                k > 0 && $i.find('option:not(:first-child)').remove();
            });

            this.dom.$form.find('[data-action="save"]').attr('data-value', '').data('value', '');
        },

        del: (val) => {

            if (typeof this.cache.customer.car[val] === 'undefined') { return; }

            _WAL.SiteGlobal.modal('slide', {

                title: this.config.lang.product_compatibility.confirm_title,
                body: this.config.lang.product_compatibility.confirm_body,
                action: this.config.lang.product_compatibility.confirm_action,
                action_callback: ($modal) => {

                    $modal.modal('hide');
                    $('body').addClass('overflow-hidden');

                    // Remove
                    this.cache.customer.car.splice(val, 1);

                    sessionStorage.setItem(this.config.customer_car_list, JSON.stringify(this.cache.customer.car));

                    this.update_customer_vehicles();

                    if(!this.cache.customer.car.length) {
                        window._WAL.SiteCart.func.update_attr({[this.config.lang.cart.shopping_for]: ''});
                    } else {
                        window._WAL.SiteCart.func.update_attr({
                            [this.config.lang.cart.shopping_for]: this.get_current_car_label(),
                        });
                    }

                    this.render_car_list();
                    this.update_ui();

                    WAL_Apploader.register('ProdConfig',  () => { _WAL.ProdConfig.preselect.bind(_WAL.ProdConfig)() });

                    _WAL.SiteGlobal.modal('slide', {

                        title: this.config.lang.product_compatibility.confirm_action_completed,
                        duration: 1500,
        
                    });
                }

            });

        },

        edit: (val) => {

            this.dom.$container.attr('data-view', 'form-edit');

            Object.keys(this.cache.customer.car[val]).forEach((k) => {
                let $f = this.dom.$form.find(`[name=${k}]`);
                $f.val(this.cache.customer.car[val][k])
                $f[0].dispatchEvent(new Event('change'));
            });

            this.dom.$form.find('[data-action="save"]').attr('data-value', val).data('value', val);

        },

        set: (val) => {

            this.cache.customer.car.unshift(this.cache.customer.car.splice(val, 1)[0]);

            sessionStorage.setItem(this.config.customer_car_list, JSON.stringify(this.cache.customer.car));

            this.update_customer_vehicles();
            window._WAL.SiteCart.func.update_attr({
                [this.config.lang.cart.shopping_for]: this.get_current_car_label()
            })

            this.update_ui();
            this.render_car_list();
            WAL_Apploader.register('ProdConfig',  () => { _WAL.ProdConfig.preselect.bind(_WAL.ProdConfig)() });
        },

        save: (val) => {

            this.user_action.autosave(val);

            this.update_ui();
            this.render_car_list();

            this.dom.$container.attr('data-view', 'list');
            WAL_Apploader.register('ProdConfig',  () => { _WAL.ProdConfig.preselect.bind(_WAL.ProdConfig)() });
        },

        autosave: (val) => {

            let data = {};
            this.dom.$input.each((k, el) => {

                let $i = $(el);
                if ($i.is('[required]') && ($i.val() == '' || $i.val() == null)) {
                    $i.addClass('is-invalid');
                    return false;
                }
                data[el.name] = $i.val();
                $i.removeClass('is-invalid');

            });

            if (this.dom.$input.length != Object.keys(data).length) { return; }

            if (typeof val == 'undefined' || val === '') {
                //this.cache.customer.car.push(data);
                this.cache.customer.car = [...[data], ...this.cache.customer.car];
            } else {
                this.cache.customer.car[val] = data;
            }

            sessionStorage.setItem(this.config.customer_car_list, JSON.stringify(this.cache.customer.car));

            this.update_customer_vehicles();
            window._WAL.SiteCart.func.update_attr({
                [this.config.lang.cart.shopping_for]: this.get_current_car_label()
            });

        },

        shop: () => {
            if (window.location.href.includes('/products/')) {
                this.update_ui();
                this.dom.$container[0].closest('modal-dialog').hide();
            } else if (window.location.href.includes('/collections/')) {
                window.location.href = window.location.pathname+'?sort_by=priority';
            } else {
                window.location.href = (Shopify?.routes?.root || '/')+'collections/shop-all?sort_by=priority';
            }
        }
    };

    preset(info = {}) {
        this.dom.$form_make.val(info?.make ?? 'none').change();
        this.dom.$form_model.val(info?.model ?? 'none').change();
        this.dom.$form_trans.val(info?.trans ?? 'none').change();
        this.dom.$form_year.val(info?.year ?? 'none').change();
        //this.dom.$container.find('[data-view="form"]').click();
    }

    test(test) {

        switch(test) {
            case -1:
                this.user_action.del(0);
                break;
            case 1:
                this.dom.$form_make.val('Toyota').change();
                this.dom.$form_model.val('86').change();
                this.dom.$form_trans.val('Manual').change();
                this.dom.$container.find('[data-view="form"]').click();
                break;
            case 2:
                this.dom.$form_make.val('Hyundai').change();
                this.dom.$form_model.val('i30 N Hatchback').change();
                this.dom.$form_trans.val('Manual').change();
                this.dom.$container.find('[data-view="form"]').click();
                break;
        }
    }

} new SiteProdCompatibility();

class SiteGlobal extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {
        modal_slide: '[data-el="site--modal-slide"]',
        modal_popup: '[data-el="site--modal-popup"]',
        compatibility_trigger: 'a[href="#compatibility_modal"]', 
        accordion: '.grid__item .accordion',
        theme_preview_bar: '#preview-bar-iframe',
        scrollable_section: '[data-el="touch-device-overlay--container"]',
        header: '.shopify-section.section-header',
        announcement_bar: '.shopify-section.announcement-bar',
        fitment_table: '.page-fitment table',
        header_product_compatibility: '.shopify-section-group-header-group.section--product-compatibility',
        homepage_banner: '.template-index .shopify-section.section--image-banner div[id^="Banner-template"]',
    };

    load() {

        // INIT MODAL
        this.dom.$modal_popup.modal({ backdrop: 'static' });
        //this.dom.$modal_popup.on('hidden.bs.modal', (e) => { $(e.target).find('.modal-footer button').off('click'); });

        this.dom.$accordion.on('click', 'summary', (e) => {
            const $this = $(e.delegateTarget);
            const sibling = $this.parent().find('details[open]').not( $this.find('details') ).get(0);
            if(sibling) {
                sibling.open = false;
                sibling.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
        });

        if (typeof (Storage) !== 'undefined' && sessionStorage.getItem('UI-CONFIG--visited') !== null) {
        } else {
            this.dom.$scrollable_section.attr('style', null);
            sessionStorage.setItem('UI-CONFIG--visited', '1');
        }

        if(window.location.hash != "#preview") {
            setTimeout(() => {
                const preview_name = this.dom.$theme_preview_bar.first().contents().find('.admin-bar p').text().trim();
                preview_name && this.log(preview_name);
                const share_url = this.dom.$theme_preview_bar.first().contents().find('.admin-bar a').attr('href');
                share_url && console.log(share_url);
                this.dom.$theme_preview_bar.slideToggle();
            }, 5000);
        }

        if(window.location.hash.includes('ContactForm') && !window.location.pathname.includes('/pages/contact')) {
            window.location.replace('/pages/contact'+window.location.search);
        }

        //this.upgrade_fitment_chart();

    }

    bind() {
        this.scrollable_section();
        
        this.resize_homepage_banner();

        this.dom.$compatibility_trigger.on('click', (e) => {
            e.preventDefault();
            document.querySelector('#ProductCompatibilityModal').show();
        });
    }

    loaded() {

        // Remove lazy load on safari as it's not yet supported
        if( (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) ) {
            document.querySelectorAll('img[loading="lazy"]').forEach((el) => {
                el.removeAttribute('loading');
            });
        }

    }

    modal(type = 'popup', config = {}) {

        const $modal = this.dom['$modal_'+type];

        if(type != 'popup') {
            this.dom['$modal_'+type].modal = (action = 'show') => {
                this.dom['$modal_'+type][0][action]();
            }
        }

        if (typeof config.title !== 'undefined' && config.title !== '' && config.title !== null) {
            $modal.find('.modal-title').html(config.title).toggle(true);
        } else {
            $modal.find('.modal-title').toggle(false);
        }

        if (typeof config.description !== 'undefined' && config.description !== '' && config.description !== null) {
            $modal.find('.modal-description').html(config.description).toggle(true);
        } else {
            $modal.find('.modal-description').toggle(false);
        }

        if (typeof config.body !== 'undefined' && config.body !== '' && config.body !== null) {
            $modal.find('.modal-body').html(config.body).toggle(true);
        } else {
            $modal.find('.modal-body').toggle(false);
        }

        if (typeof config.action !== 'undefined' && config.action !== '' && config.action !== null) {
            $modal.find('.modal-footer .button--primary [data-el="modal--action-init"]').html(config.action);
        }

        if (typeof config.action_secondary !== 'undefined' && config.action_secondary !== '' && config.action_secondary !== null) {
            $modal.find('.modal-footer .button:not(.button--primary) [data-el="modal--action-init"]').html(config.action_secondary);
        }

        if (typeof config.action === 'undefined' && typeof config.action_secondary === 'undefined') {
            $modal.find('.modal-footer').toggle(false);
        } else {
            $modal.find('.modal-footer').toggle(true);
        }

        if (typeof config.duration !== 'undefined' && config.duration !== '' && config.duration !== null) {
            setTimeout(() => {
                $modal.modal('hide');
            }, config.duration);
        }

        $modal.children().toggleClass('modal__content_dark', !!config.dark_mode);

        // Callback
        $modal.find('.modal-footer button.button--primary').off().one('click', () => {
            if (typeof config.action_callback == 'function') {
                const $btn = $modal.find('.modal-footer button.button--primary');
                $btn.attr('data-loading', 'true');

                const cb = config.action_callback($modal);
                if(cb instanceof Promise) {
                    cb.finally(() => {
                        $btn.removeAttr('data-loading');
                    });
                } else {
                    setTimeout(() => { $btn.removeAttr('data-loading'); }, 1000);
                }
            } else {
                $modal.modal('hide');
            }                
        });
        $modal.find('.modal-footer button:not(.button--primary)').off().one('click', () => {
            if (typeof config.action_secondary_callback == 'function') {
                const $btn = $modal.find('.modal-footer button:not(.button--primary)');
                $btn.attr('data-loading', 'true');

                const cb = config.action_secondary_callback($modal);
                if(cb instanceof Promise) {
                    cb.finally(() => {
                        $btn.removeAttr('data-loading');
                    });
                } else {
                    setTimeout(() => { $btn.removeAttr('data-loading'); }, 1000);
                }
            } else {
                $modal.modal('hide');
            }                
        });

        // Size
        $modal.find('.modal-dialog').toggleClass('modal-lg', config.large == true);

        $modal.modal('show');
    }

    scrollable_section() {
        let touchStartX = 0;
        let touchEndX = 0;

        this.dom.$scrollable_section.on('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        });

        this.dom.$scrollable_section.on('touchmove', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            e.currentTarget.style.opacity = 0;
            const swipeDistance = touchStartX - touchEndX;
            swipeDistance > 0 && e.currentTarget.parentElement.scrollTo(swipeDistance, 0);
        });

        this.dom.$scrollable_section.on('touchend', (e) => {
            const swipeDistance = touchStartX - touchEndX;
            swipeDistance > 50 && e.currentTarget.remove();
        });

        setTimeout(() => {
            this.dom.$scrollable_section.remove();
        }, 8000);
    }

    calc_header(unit = '') {
        const h = Math.floor(this.dom.$header.height() + (this.dom.$announcement_bar.height() || 0));
        return unit == '' ? h : h+unit;
    }

    upgrade_fitment_chart() {

        if(!this.dom.fitment_table.length) { return; }

        fetch(`${this.config.primary_store}/pages/${this.config.fitment_page_handle}.json`).then(r => r.json()).then((html) => {

            html = html.page.body_html.replaceAll(this.config.primary_store, '');

            const controls = '<div>test</div>';

            this.dom.$fitment_table[0].outerHTML = controls+html;
            
        });
    }

    resize_homepage_banner() {
        const cb = () => {
            if( window.scrollY ) { return; }
            clearTimeout(this.cache.timeout);
            this.cache.timeout = setTimeout(() => {
                const offset = window.innerHeight - (this.calc_header() + ((this.dom.$header_product_compatibility.is(':visible') && this.dom.$header_product_compatibility.height()) || 0));
                this.dom.$homepage_banner.first().css('height', `${offset}px`);
            }, 100);
        };
        $('html').on('header:resized', cb).trigger('header:resized');
        $(window).on('resize', cb);
    }

} new SiteGlobal();

class ColFilter extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: '#ProductGridContainer',
        _loading_overlay: '.loading-overlay',
        _cards_container: '#product-grid',
        _empty_cards_container: '.collection-product-grid--empty',

        sort_btn__type: '.container--col-sorting button[data-el-value]',
        //sort_btn__order: '.container--col-sorting .dropdown-menu a.dropdown-item',
        sort_btn__order: '.container--col-sorting select',

        //pagination: 'template[data-el="pagination--template"]',
        pagination_trigger: '[data-el="pagination--trigger"]',

    };

    load() {

        this.cache.url = this.url.get_path();

        // get selected filters (product tags)
        if (typeof this.cache.url[2] != 'undefined' && this.cache.url[2] != '') {
            this.cache.selected_filter = this.cache.url[2].toLowerCase().split('+');
        }

        // get current page number
        if (location.search != '' && location.search != '?') {
            let page_num = this.url.get_param('page');
            if (page_num) {
                page_num = parseInt(page_num);
                this.view.pagination.current_page = page_num;
            }
        }

        // get products per page
        if (this.config.collection?.pagination) {
            this.view.pagination.ppp = this.config.collection.pagination;
        }

        // Get current Collection
        this.cache.current_collection = this.cache.url[1];

        if (typeof (Storage) !== 'undefined' && sessionStorage.getItem(`COLLECTION--${this.cache.current_collection}`) !== null) {
            this.cache.all_products = JSON.parse(sessionStorage.getItem(`COLLECTION--${this.cache.current_collection}`));
            this.view.pagination.total_page = Math.ceil(this.cache.all_products.length / this.view.pagination.ppp);
            this.filter().then(this.view.pagination.load_page);
        } else {
            this.get_products().then(() => { this.filter(); }).then(this.view.pagination.load_page);
        }
    }

    bind() {

        this.dom.$sort_btn__type.on('click', (e) => {

            e.preventDefault();

            let new_url = new URL(window.location.href);
            new_url.searchParams.set('sort_by', e.currentTarget.dataset.elValue);
            new_url.searchParams.set('page', 1);

            window.location.href = new_url.toString();

        });
        this.dom.$sort_btn__order.on('change', (e) => {
            e.preventDefault();

            let new_url = new URL(window.location.href);
            new_url.searchParams.set('sort_by', e.currentTarget.value);
            new_url.searchParams.set('page', 1);

            history.pushState({}, '', new_url);
            this.view.reinit();
            //window.location.href = new_url.toString();
        });

        if(this.dom.$pagination_trigger.length) {
            $(window).on('scroll', () => {
                if( this.dom.$pagination_trigger.isInViewport() ) {
                    this.view.pagination.load_next();
                }
            });
        }
    }

    get_collection() {
        return fetch(`${Shopify?.routes?.root || '/'}collections/${this.cache.current_collection}.json`)
            .then(r => r.json())
            .then(r => this.cache.collection = r.collection);
    }

    get_products() {
        return fetch(`${Shopify?.routes?.root || '/'}collections/${this.cache.current_collection}?view=content-json`)
            .then(r => r.json())
            .then((r) => {
                sessionStorage.setItem(`COLLECTION--${this.cache.current_collection}`, JSON.stringify(r));
                this.cache.all_products = r;
                return r;
            });
    }

    view = {

        toggle: (section = '', state = true) => {

            switch (section) {

                case 'loading':
                    this.dom.$loading_overlay.removeClass('d-none');
                    this.dom.$cards_container.addClass('d-none');
                    this.dom.$empty_cards_container.addClass('d-none');
                    break;

                case 'empty-result':
                    this.dom.$empty_cards_container.removeClass('d-none');
                    this.dom.$loading_overlay.addClass('d-none');
                    this.dom.$cards_container.addClass('d-none');
                    break;

                case 'content':
                    this.dom.$empty_cards_container.addClass('d-none');
                    this.dom.$loading_overlay.addClass('d-none');
                    this.dom.$cards_container.removeClass('d-none');

                default:
                // Do nothing

            }

        },

        reinit: () => {
            this.dom.$pagination_trigger.show();
            this.view.pagination.current_page = 1;
            this.dom.$cards_container.empty();
            this.load();
        },

        render: {

            is_loading: false,
            has_content: false,

            page: (handles = []) => {

                if( this.view.render.is_loading ) { return; }
                this.view.render.is_loading = true;

                // Add placeholder
                this.dom.$cards_container.append(handles.map((h) => `<li class="d-none" data-handle="${h}"></li>`).join(''));
                handles.map((h) => {
                    fetch(`${Shopify?.routes?.root || '/'}collections/${this.cache.current_collection}/products/${h}/?view=collection-card`)
                        .then(r => r.text())
                        .then(r => {
                            this.dom.$cards_container.find(`[data-handle="${h}"]`).replaceWith(r);
                            handles = handles.filter(x => x != h);

                            this.view.render.has_content = true;
                            if(!handles.length) {
                                this.view.render.is_loading = false;
                            }
                        });
                });
            },
        },

        pagination: {

            ppp: 9, //post per page
            current_page: 1,
            total_page: 1,

            load_page: () => {
                const end_index = this.view.pagination.ppp * this.view.pagination.current_page;
                const start_index = end_index - this.view.pagination.ppp;
                let handles = this.cache.all_products.slice(start_index, end_index).map(p => p.handle);

                if (handles.length > 0) {
                    this.view.render.page(handles);
                    this.view.toggle('content');
                    //this.view.pagination.paginate();

                } else if(this.view.pagination.current_page == 1) {
                    this.view.toggle('empty-result');
                }
            },

            load_next: () => {
                if(this.view.render.is_loading || !this.view.render.has_content) { return; }

                this.view.pagination.current_page += 1;
                this.view.pagination.load_page();

                if( this.view.pagination.current_page >= this.view.pagination.total_page ) {
                   this.dom.$pagination_trigger.hide();
                }
            },

            paginate: () => {

                // reset content
                this.dom.$pagination.siblings().remove();

                this.view.pagination.total_page = Math.ceil(this.cache.all_products.length / this.view.pagination.ppp);
                const total_page = this.view.pagination.total_page;

                const URL = new URLSearchParams(location.search);

                let $temp_dom = $(this.dom.$pagination.html());
                let $el = null;

                // SINGLE PAGE - NO PAGINATION NEEDED
                if (total_page == 1) { return; }

                // PREV BTN
                if (this.view.pagination.current_page !== 1) {
                    $el = $temp_dom.find('a[class*="prev"]').closest('li').clone();
                    URL.set('page', this.view.pagination.current_page - 1);
                    $el.find('a').attr('href', window.location.pathname + '?' + URL.toString());
                    this.dom.$pagination.parent().append($el);
                }

                // PAGES
                let jump_first = false;
                let jump_last = false;
                for (let loop = 1; loop <= total_page; loop++) {

                    if (loop < (this.view.pagination.current_page - 1) && jump_first == false) {
                        jump_first = true;

                        $el = $temp_dom.find('a:not([class*="prev"]):not([class*="next"])').closest('li').clone();
                        URL.set('page', 1);
                        $el.find('a')
                            .text(1)
                            .attr('href', window.location.pathname + '?' + URL.toString());
                        this.dom.$pagination.parent().append($el);

                        $el = $temp_dom.find('span').closest('li').clone();
                        $el.find('span').text('...');
                        this.dom.$pagination.parent().append($el);

                    } else if (loop > (this.view.pagination.current_page + 1) && jump_last == false) {
                        jump_last = true;

                        $el = $temp_dom.find('span').closest('li').clone();
                        $el.find('span').text('...');
                        this.dom.$pagination.parent().append($el);

                        $el = $temp_dom.find('a:not([class*="prev"]):not([class*="next"])').closest('li').clone();
                        URL.set('page', total_page);
                        $el.find('a')
                            .text(total_page)
                            .attr('href', window.location.pathname + '?' + URL.toString());
                        this.dom.$pagination.parent().append($el);
                    }

                    if (loop < (this.view.pagination.current_page - 1) || loop > (this.view.pagination.current_page + 1)) { continue; }

                    if (loop == this.view.pagination.current_page) {
                        $el = $temp_dom.find('span').closest('li').clone();
                        $el.find('span').text(loop);
                        this.dom.$pagination.parent().append($el);
                    } else {
                        $el = $temp_dom.find('a:not([class*="prev"]):not([class*="next"])').closest('li').clone();
                        URL.set('page', loop);
                        $el.find('a')
                            .text(loop)
                            .attr('href', window.location.pathname + '?' + URL.toString());
                        this.dom.$pagination.parent().append($el);
                    }
                }

                // NEXT BTN
                if (this.view.pagination.current_page !== total_page) {
                    $el = $temp_dom.find('a[class*="next"]').closest('li').clone();
                    URL.set('page', this.view.pagination.current_page + 1);
                    $el.find('a').attr('href', window.location.pathname + '?' + URL.toString());
                    this.dom.$pagination.parent().append($el);
                }
            }
        },
    };

    filter() { //---
        if (this.cache?.selected_filter?.length > 0) {
            this.cache.all_products = this.cache.all_products.filter((n) => {
                return n.tags.filter((x) => {
                    return this.cache.selected_filter.includes(x.dashcase());
                }).length > 0;
            });
        }

        return this.sort.init();
    };

    sort = {

        init: () => {

            if (this.config.default_sort == 'manual') { return; }
            else if (this.url.get_param('sort_by').includes('priority') || (this.url.get_param('sort_by') == '' && _WAL.SiteProdCompatibility.cache.customer.car.length )) {

                // EXTERNAL DATA
                return _WAL.SiteProdCompatibility.get_compatible_prods().then(this.sort.priority);

            }
            //else if ( this.url.get_param('sort_by') == 'priority' ) { this.sort.priority(); }
            else {

                (this.url.get_param('sort_by') || '').split('+').forEach((sort_type) => {

                    let sort = sort_type.split('-');
                    // Example: ['title', 'ascending']

                    if (sort.length > 0 && sort[0] !== '') {

                        try {

                            this.sort.by_prop(sort[0], sort[1]);

                        } catch (error) { /* do nothing */ }

                    }

                });

                return Promise.resolve('');

            }

        },

        priority: (compatible_prod = []) => {

            this.cache.all_products = this.cache.all_products
            .sort((a, b) => {

                // -1 Move A to left
                // 1 Move A to right
                // 0 Do nothing

                const generic = this.config.generic_collection;
                
                if (a.collections.includes(generic) && !b.collections.includes(generic)) { return -1; }
                else if (a.collections.includes(generic) && !b.collections.includes(generic)) { return 1; }
                return 0; // Equal

            }).sort((a, b) => {

                // -1 Move A to left
                // 1 Move A to right
                // 0 Do nothing

                const generic = this.config.generic_collection;

                const a_compatible = compatible_prod.includes(a.handle) || a.bundle.filter(x => compatible_prod.includes(x)).length > 0;
                const b_compatible = compatible_prod.includes(b.handle) || b.bundle.filter(x => compatible_prod.includes(x)).length > 0;

                if ((a_compatible && !b_compatible) || (a.collections.includes(generic) && !b.collections.includes(generic))) { return -1; } 
                else if ((!a_compatible && b_compatible) || (!a.collections.includes(generic) && b.collections.includes(generic))) { return 1; }
                
                return 0; // Equal

            });

        },

        by_prop: (prop = '', sort_type = 'ascending') => {

            if (prop == '' || typeof this.cache.all_products[0][prop] == 'undefined') { return; }

            if (sort_type == 'ascending') {

                this.cache.all_products = this.cache.all_products.sort((a, b) => {

                    if (a[prop] < b[prop]) { return -1; }
                    if (a[prop] > b[prop]) { return 1; }
                    return 0;

                });

            } else {

                this.cache.all_products = this.cache.all_products.sort((a, b) => {

                    if (a[prop] < b[prop]) { return 1; }
                    if (a[prop] > b[prop]) { return -1; }
                    return 0;

                });

            }

        },

    };

} new ColFilter();

class ColList extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        //container: '',
        svg: 'svg[data-src]',

    };

    load() {

        this.dom.$svg.each((k, el) => {

            fetch(el.dataset.src).then(r => r.text()).then((r) => {

                r.includes('AccessDenied') ? el.style.display = 'none' : el.parentElement.innerHTML = r;

            });

        });

    }

} new ColList();

class ProdHero extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {
        header_product_compatibility: '.shopify-section-group-header-group.section--product-compatibility',

        container: '#MainContent > .shopify-section slideshow-component',
        _img_containers: '.product__media',

        _video: 'video',
        _vol_btn: '.btn-video-control',
    };

    bind() {

        WAL_Apploader.register('SiteGlobal',  () => {
            const cb = () => {
                if( window.scrollY ) { return; }
                clearTimeout(this.cache.timeout);
                this.cache.timeout = setTimeout(() => {
                    const offset = _WAL.SiteGlobal.calc_header() + ((this.dom.$header_product_compatibility.is(':visible') && this.dom.$header_product_compatibility.height()) || 0);
                    this.dom.$img_containers
                        .css('--header-offset', offset+'px')
                        .css('height', `${window.innerHeight - offset}px`);
                }, 100);
            };
            $('html').on('header:resized', cb).trigger('header:resized');
            $(window).on('resize', cb);
        });

        this.dom.$vol_btn.on('click', (e) => {

            let $this = $(e.currentTarget);
            $this.find('i').toggleClass('d-none');
            $this.siblings(this.dom._video)[0].muted = $this.find('.bi-volume-up-fill').hasClass('d-none');

        });

        this.dom.$video.on('click', (e) => {

            e.currentTarget.play();
            e.currentTarget.dataset.playing = 'true';

        });
    }

    loaded() {

        if (this.dom.$video.length == 1) {
            this.dom.$video[0].loop = true;
        }

        /*
        TO DO
            - Pause video on focus out
            - Play video on focus in
        */

    }

} new ProdHero();

class ProdTheme extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: '.shopify-section.product-theme',
        _overlay: '.product-overlay--modal-bg',

        _temp_css: '#product-overlay--temp-styles',

    };

    bind() {

        this.dom.$overlay.on('click', (e) => {

            _WAL.ProdHero.dom.$container[0].slider.scrollTo({ left: 0 });
            _WAL.ProdHero.dom.$container.find('li:first-child video')[0]?.play();

            this.dom.$overlay.fadeOut(500);
            this.dom.$container.fadeOut(1800);
            this.dom.$temp_css.remove();

        });
    }

    //loaded() {}

} new ProdTheme();

class ProdSpecs extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: '.template-product .shopify-section .image-with-text',

        _img: '.image-with-text__media-item img',
        _specs: '[data-source="product.metafields.content.metadata"]',
        _disclaimer_img: '[data-container="disclaimer.img"]',
        
        _accordion: '.accordion details',
        
        media_container: '.image-with-text__media-item',
        media_3d_model: '[data-product-media-3d]',

        header: '.section-header'

    };

    config = {

        img: 'featured.png',

    };

    load() {

        this.load_featured_img();
        this.format_specs();
        this.load_disclaimer_images();

        this.dom.$accordion.on('click', (e) => {

            const $this = $(e.currentTarget);
            if (!e.currentTarget.open) {
                $this.parent().siblings().find('details[open]').each((k, el) => {
                    el.open = false;
                });

                window.scrollTo({ behavior: "smooth", top: $this.offset().top - this.dom.$header.height() - 15 });

            }

        });

    }

    load_featured_img() {

        if (this.dom.$media_3d_model.html().trim() !== '') {

            this.dom.$img.parent().replaceWith(this.dom.$media_3d_model.html().trim());

        } else {

            const img_url = `products-2.0/${this.current_product.handle}/web/${this.config.img}`;

            this.aws.has(img_url).then((img_url) => {
                this.helper.img.load(this.dom.$img, img_url);
            }).catch((err) => {
                console.log('Image not found: '+ img_url);
            });

        }

    }

    format_specs() {

        /*
            REQUIRES
            <div data-source="product.metafields.content.metadata">{{ product.metafields.content.metadata.value | json }}</div>
        */
            
        if (this.dom.$specs.length == 0 || this.dom.$specs.text() === '' || this.dom.$specs.text() === 'null') {
            this.dom.$specs.closest('.accordion').hide();
            return;
        }

        this.dom.$specs.hide();
        let li = '';
        $.each(JSON.parse(this.dom.$specs.text()), (k, v) => {
            v = v.split('||');
            li += `<li><span>${v[0].trim()}</span><span class="value">${v[1].trim()}</span></li>`;
        });
        this.dom.$specs.after(`<ul>${li}</ul>`);

    }

    load_disclaimer_images() {

        /*
            REQUIRES
            <div data-container="disclaimer.img" class="d-flex">{{ product.metafields.content.metaicon.value | json }}</div>
        */

        if (this.dom.$disclaimer_img.length == 0 || this.dom.$disclaimer_img.text() === '') { return; }

        let $images = [[]];
        (JSON.parse(this.dom.$disclaimer_img.text()) || []).forEach(($fname, i) => {
            const src = $fname.includes('http:') || $fname.includes('https:') ? $fname : this.aws.url('web/icons/' + $fname.trim());
            //((i + 1) % 2) == 1 ? $images.push([[`<img src="${src}" />`]]) : $images[Math.floor(i/2)].push(`<img src="${src}" />`);
            $images[0].push([[`<img src="${src}" />`]]);
        });

        this.dom.$disclaimer_img.html(this.layout($images));

    }

} new ProdSpecs();

class ProdKlaviyo extends WAL {

    constructor() {
        super();
        this.init();
    }

    should_init() { return !!this.config.klaviyo_bis; }

    bis(variant = null) {
        if (typeof variant == 'undefined' || variant === null) { return; }
        console.log(variant);

        _WAL.SiteGlobal.modal('slide', {

            title: this.config.lang.bis.title,
            description: this.config.lang.bis.description,
            action: this.config.lang.bis.action,
            body: `<div class="d-flex flex-column align-items-center">
                <p class="font-helvetica">${variant.product.title} (${variant.title})</p>
                <img src="${variant.featured_image?.src || variant.product.featured_image }" class="mb-3 object-fit-contain" width="200" height="200" />
                <div class="w-100" style="position: relative;">
                    <input type="email" class="field__input font-helvetica" value="${this.config.customer.email || ''}" />
                    <label class="field__label font-helvetica">Email</label>
                </div>
                <small class="text-start mt-3">${this.config.lang.bis.note}</small>
            </div>`,
            action_callback: ($modal) => {;

                fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+this.config.klaviyo_bis, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "revision":"2024-06-15"
                    },
                    body: JSON.stringify({
                        "data": {
                            "type": "back-in-stock-subscription",
                            "attributes": {
                            "profile": {
                                "data": {
                                    "type": "profile",
                                    "attributes": {
                                        "email": $modal.find('input[type="email"]').val().trim(),
                                    }
                                }
                            },
                            "channels": ["EMAIL"],
                            },
                            "relationships": {
                                "variant": {
                                    "data": {
                                        "type": "catalog-variant",
                                        "id": "$shopify:::$default:::"+variant.id,
                                    }
                                }
                            }
                        }
                    }),
                })
                .then(result => _WAL.SiteGlobal.modal('slide', {
                        title: this.config.lang.bis.title,
                        description: this.config.lang.bis.description,
                        body: this.config.lang.bis.success,
                    })
                )
                .catch(error => console.log('error', error));

            },
        });
    }

} new ProdKlaviyo();

class ProdBIS extends WAL {

    /*
        Requires SC Back in Stock (https://apps.shopify.com/out-of-stock-1) app to be installed.
    */

    constructor() {
        super();
        this.init();
    }

    trigger(variant = null) {
        if (typeof variant == 'undefined' || variant === null) { return; }
        console.log(variant);

        _WAL.SiteGlobal.modal('slide', {

            title: this.config.lang.bis.title,
            description: this.config.lang.bis.description,
            action: this.config.lang.bis.action,
            body: `<div class="d-flex flex-column align-items-center">
                <p class="font-helvetica">${variant.product.title} (${variant.title})</p>
                <img src="${variant.featured_image?.src || variant.product.featured_image }" class="mb-3 object-fit-contain" width="200" height="200" />
                <div class="w-100" style="position: relative;">
                    <input type="email" class="field__input font-helvetica" value="${this.config.customer.email || ''}" />
                    <label class="field__label font-helvetica">Email</label>
                </div>
                <small class="text-start mt-3">${this.config.lang.bis.note}</small>
            </div>`,
            action_callback: ($modal) => {;

                fetch('https://back-in-stock.shopcircle.co/api/public/subscribe/email', {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json, text/plain, */*",
                    },
                    body: JSON.stringify({
                        destination: $modal.find('input[type="email"]').val().trim(),
                        variant_id: variant.id,
                        product_id: null,
                        alertType: "email",
                        country: null,
                        marketing: false,
                        domain: this.config.myshopify,
                    }),
                })
                .then(r => r.json())
                .then(r => {
                    _WAL.SiteGlobal.modal('slide', {
                        title: this.config.lang.bis.title,
                        description: this.config.lang.bis.description,
                        //body: r.ok ? this.config.lang.bis.success : this.config.lang.bis.failed,
                        body: r.success ? this.config.lang.bis.success : r.message,
                    });
                }
                )
                .catch(error => console.log('error', error));

            },
        });
    }

} new ProdBIS();

class ProdConfig extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: '.template-product .shopify-section.product-configurator',

        _card_container: '[data-el="product-configurator--container"]',
        _card_card: '[data-el="product-configurator--card"]',
        _display_counter: '[data-el="product-configurator--display-counter"]',
        _card_info: '[data-el="product-configurator--info"]',
        _card_content: '[data-el="product-configurator--content"]',
        _card_image: '[data-el="product-configurator--image"]',
        _card_badges: '[data-el="product-configurator--badges"]',
        _card_options: '[data-el="product-configurator--options"]',
        _card_option: '[data-el="product-configurator--option"]',
        _card_prod_options: '[data-el="product-configurator--prod-options"]',
        _card_prod_options_swatch: '[data-el-type="swatch"]',
        _card_prod_options_var: '[data-el="product-configurator--prod-options-var"]',
        _card_title: '[data-el="product-configurator--title"]',
        _card_confirm: '[data-confirm]',
        _card_prod_title: '[data-el="product-configurator--prod-title"]',
        _card_var_title: '[data-el="product-configurator--var-title"]',
        _card_var_unavailable: '[data-el="product-configurator--var-unavailable"]',
        _card_compare_at_price: '[data-el="product-configurator--compare-at-price"]',
        _card_discount_badge: '[data-el="product-configurator--discount-badge"]',
        _card_price: '[data-el="product-configurator--price"]',
        _card_next_add_btn: '[data-el="product-configurator--next-add-btn"]',
        _card_next_del_btn: '[data-el="product-configurator--next-del-btn"]',
        _card_edit_btn: '[data-el="product-configurator--edit-btn"]',
        _card_divider: '[data-el="product-configurator--divider"]',
        _card_scrollable_ctrl: '[data-el="product-configurator--scrollable-ctrl"]',

        _card_engraving_type: '[data-prod-handles*="engraving"]',

        _card_summary_container: '[data-el="product-configurator--summary-container"]',
        _card_summary: '[data-el="product-configurator--summary"]',
        _card_summary_img_container: '[data-el="product-configurator--summary-img-container"]',
        _card_summary_img: '[data-el="product-configurator--summary-img"]',
        _card_summary_share: '[data-el="product-configurator--share"]',
        //_card_summary_email_template: 'template[data-el="product-configurator--summary-email"]',

        _input_cart_properties: '[data-el="product-configurator--cart-properties"]',

        _btn_add_to_cart: '[data-el="product-configurator--add-to-cart"]',
        _btn_add_to_cart_init: '[data-el="product-configurator--add-to-cart-init"]',
        _btn_add_to_cart_loading: '[data-el="product-configurator--add-to-cart-loading"]',
        _btn_add_to_cart_added: '[data-el="product-configurator--add-to-cart-added"]',

        product_preview: '[data-el="product-configurator--product-preview"]',

        start_customise: '[href="#customise"]',
        product_compatibility: 'product-compatibility-modal',
        header: 'header',
    };

    cache = {
        invalid_img_urls: [],
    };

    config = {
        coming_soon_tag: 'coming-soon',
    };

    data = {

        product: {},
        bundle_items: [],

    };

    draft_cart = {};

    should_init() {
        return true;
        return !_WAL_CONFIG.product.variants[0].sku.includes('--');
    }

    load() {

        this.data.bundle_items = this.config.bundle_items;

        this.data.product = this.current_product;
        this.draft_cart[this.data.product.handle] = { id: this.data.product.variants[0].id, prop: {} };

        // format data
        this.data.product.variants.forEach((v, key) => {
            this.data.product.variants[key].product = this.data.product;
        });
        this.data.bundle_items.forEach((bundle_item, key) => {
            bundle_item.options.forEach((v, k) => {
                this.data.bundle_items[key].options[k].product = bundle_item.option_products[v.id];
            });
        });

        this.update_ui__v2();
    }

    bind() {
        // CARD CHECKBOX
        this.dom.$card_title.find('input:not([disabled])').on('change', (e) => {

            let $this = $(e.currentTarget);
            let $container = $this.closest(this.dom._card_container);
            let $content = $container.find(this.dom._card_content);

            
            if ($this.is(this.dom._card_confirm) && !$this.is(':checked')) {

                const $vDOM = $(this.data.bundle_items[ $container.data('bundle-index') ].removal_confirmation);
                const modal_title = $vDOM.find('h1').length ? $vDOM.find('h1').text() : '';
                $vDOM.find('h1').remove();
                const modal_body = $vDOM.html();
                
                _WAL.SiteGlobal.modal('slide', {
                    title: modal_title || this.config.lang.product.confirm_title,
                    body: modal_body || this.config.lang.product.confirm_body,
                    action: this.config.lang.product.confirm_action,
                    action_callback: ($modal) => {

                        $modal.modal('hide');

                        //let $container = this.dom.$card_container.eq(parseInt($this.data('confirm')) + 1); // +1 to exclude the main product

                        console.log([
                            this.dom.$card_container,
                            (parseInt($this.data('confirm')) + 1),
                            this.dom.$card_container.eq(parseInt($this.data('confirm')) + 1)
                        ]);
                        

                        $container.find(this.dom._card_title + ' input').prop('checked', false);
                        $container.find(this.dom._card_content).slideUp(() => {

                            let top_offset = $container.nextAll().filter((k, el) => !el.classList.contains('d-none')).first().offset().top
                            top_offset -= this.dom.$header.closest('.shopify-section').outerHeight();
                            top_offset += 36;

                            $([document.documentElement, document.body]).animate({
                                scrollTop: top_offset
                            }, 500, 'linear');

                        });

                        this.update_ui__v2();
                    }
                });
                $this.prop('checked', true);
                e.preventDefault();
                e.stopImmediatePropagation();
                return;

            }

            !$this.is(':checked') ? $content.slideUp() : $content.slideDown();

            this.update_ui__v2();

        });

        this.dom.$card_title.find('input:not([disabled])').on('change', this.load_engraving_img.bind(this));

        // NEXT DEL BTN (NO THANKS BTN)
        this.dom.$card_next_del_btn.on('click', (e) => {
            let $input = $(e.currentTarget).closest(this.dom._card_container).find(this.dom._card_title + ' input');
            if (!$input.is('[disabled]')) {
                $input.prop('checked', false).trigger('change');
            }
        });

        /* ==============================================================================
            To be added to the top offset calculation if the SiteStoreSelect is enabled
            - START CUSTOMISE
            - NEXT ADD BUTTON
            - BACK BUTTON
        ============================================================================== */
        // WAL_Apploader.register('SiteStoreSelect', () => {
        //     if( _WAL.SiteStoreSelect.dom.$container.is(':visible') ) {
        //         top_offset += _WAL.SiteStoreSelect.dom.$container.outerHeight();
        //         _WAL.SiteStoreSelect.toggle_store_selector(false);
        //     }
        // });
        /* ==============================================================================
        ============================================================================== */

        // START CUSTOMISE
        this.dom.$start_customise.on('click', (e) => {
            e.preventDefault();
            let top_offset = this.dom.$container.first().offset().top;
            top_offset -= this.dom.$header.closest('.shopify-section').outerHeight();
            top_offset -= _WAL.SiteProdCompatibility?.dom?.$section_ui?.height() || 0;
            top_offset += 36;

            $([document.documentElement, document.body]).animate({ scrollTop: top_offset }, 500);
        });

        //NEXT ADD BUTTON
        this.dom.$card_next_add_btn.on('click', (e) => {
        

            let $this = $(e.currentTarget);
            let current_card = $this.closest([this.dom._card_container, this.dom.product_preview].join(', ')).first();
            let next_card = current_card
                .nextAll(this.dom._card_container + ':not(.d-none):not(.visually-hidden), ' + this.dom.product_preview + ':not(.d-none):not(.visually-hidden)')
                .filter((k, el) => $(el).css('display') != 'none')
            ;
            next_card = next_card.length ? next_card.first() : this.dom.$card_summary_container;

            let top_offset = next_card.offset().top;
            top_offset -= this.dom.$header.closest('.shopify-section').outerHeight();
            top_offset -= _WAL.SiteProdCompatibility?.dom?.$section_ui?.height() || 0;
            top_offset += 36;

            // is SOLD OUT
            if( $this.data('disabled') ) {
                // WAL_Apploader.register('ProdKlaviyo', () => {                        
                //     window._WAL.ProdKlaviyo.bis( this.get_selected_var($this) );
                // });
                WAL_Apploader.register('ProdBIS', () => {                        
                    window._WAL.ProdBIS.trigger( this.get_selected_var($this) );
                });
            }

            $([document.documentElement, document.body]).animate({ scrollTop: top_offset }, 500);
        });

        //BACK BUTTON
        this.dom.$card_edit_btn.on('click', (e) => {
            let target_card = this.get_active_container().first();

            let top_offset = target_card.offset().top;
            top_offset -= this.dom.$header.closest('.shopify-section').outerHeight();
            top_offset -= _WAL.SiteProdCompatibility?.dom?.$section_ui?.height() || 0;
            top_offset += 36;

            $([document.documentElement, document.body]).animate({ scrollTop: top_offset }, 500);
        });

        //ADD TO CART BUTTON
        this.dom.$btn_add_to_cart.on('click', this.draft_cart__add.bind(this));

        // MAIN PRODUCT
        this.dom.$card_container.filter(`[data-prod-handles="${this.data.product.handle}"]`).find('.carousel').on('slide.bs.carousel', (e) => {
            const $this = $(e.currentTarget);
            const $slides = $this.find('.carousel-item');
            const $slide = $(e.relatedTarget);

            let vals = [];
            $slides.eq(0).length ? vals.push($slides.eq(0).find('.selected').data('val')) : null;
            $slides.eq(1).length ? vals.push($slides.eq(1).find('.selected').data('val')) : null;
            $slides.eq(2).length ? vals.push($slides.eq(2).find('.selected').data('val')) : null;

            let first_avail = false;
            let selected_var_exists = this.get_variant__by_title(vals.join(' / ')) !== false;

            if (e.to != 0) { // !first-child
                $slide.find('button[data-val]').each((k, btn) => {
                    const $btn = $(btn);
                    vals[e.to] = $btn.data('val');
                    const variant = this.get_variant__by_title( vals.join(' / ') );
                    $(btn).toggle( variant !== false );
                    if (!selected_var_exists && variant !== false && !first_avail) {
                        $btn.trigger('click');
                        first_avail = true;
                    }
                });
            }
        });
        this.dom.$card_container.filter(`[data-prod-handles="${this.data.product.handle}"]`).find(this.dom._card_options + ' button[data-val]').on('click', (e) => {

            let $this = $(e.currentTarget);
            if ($this.hasClass('color-swatch')) {
                $this.addClass('color-swatch--active selected');
                $this.siblings('.color-swatch--active.selected').removeClass('color-swatch--active selected')
            } else {
                $this.removeClass('button--secondary').addClass('button--primary selected');
                $this.siblings('.button--primary.selected').removeClass('button--primary selected').addClass('button--secondary');
            }

            let vals = [];
            if($this.is('[data-option-index="0"]')) {
                const $opts = $this.closest(this.dom._card_options).find('> div:not(.card__badges)');
                $opts.eq(0).length ? vals.push($opts.eq(0).find('.selected').data('val')) : null;
                $opts.eq(1).length ? vals.push($opts.eq(1).find('.selected').data('val')) : null;
                $opts.eq(2).length ? vals.push($opts.eq(2).find('.selected').data('val')) : null;
                const current_vals = this.get_variant__by_title(vals.join(' / '));

                // 2nd or 3rd option
                $opts.filter(':gt(0)').each((k, el) => {
                    let first = true;
                    const $opt = $(el);
                    $opt.find('button[data-val]').each((k, btn) => {
                        const $btn = $(btn);
                        let v = vals;
                        v[$opt.index()] = $btn.data('val');
                        const variant = this.get_variant__by_title(v.join(' / '));
                        $btn.toggle(!!variant);
                        if(variant && first && !current_vals) {
                            first = false;
                            if ($btn.hasClass('color-swatch')) {
                                $btn.addClass('color-swatch--active selected');
                                $btn.siblings('.color-swatch--active.selected').removeClass('color-swatch--active selected');
                            } else {
                                $btn.removeClass('button--secondary').addClass('button--primary selected');
                                $btn.siblings('.button--primary.selected').removeClass('button--primary selected').addClass('button--secondary');
                            }
                        }
                    });
                });
            }

            const variant = this.get_selected_var($this);

            if (variant) {
                $this.closest(this.dom._card_container).find(this.dom._card_var_title).text(variant.public_title);
                $this.closest(this.dom._card_container).find(this.dom._card_var_unavailable).toggleClass('d-none', variant.available);
                this.update_ui__card_price($this, variant);

                const img_src = variant.featured_image && variant.featured_image.src != '' ? variant.featured_image.src.split('?')[0]+'?width=500' : this.config.placeholder.image;
                
                this.helper.img.load(
                    $this.closest(this.dom._card_container).find(this.dom._card_image),
                    img_src
                );

                if(!this.config.bundle_items.length) {
                    this.helper.img.load(
                        this.dom.$card_summary_img,
                        img_src
                    );
                }

            }

            this.update_ui__v2();

        }).first().click();

        // BUNDLE CARDS
        this.dom.$card_prod_options.find('label').on('click', (e) => {

            let $this = $(e.currentTarget);
            let $input = $this.siblings(`input[id="${$this.attr('for')}"]`);
            const is_swatch = $this.closest(this.dom._card_prod_options).is(this.dom._card_prod_options_swatch);
        
            $input.prop('checked', true);

            // Set current Product active state
            if(is_swatch) {
                $this.closest(this.dom._card_content).find(this.dom._card_prod_title).text($this.data('val'));
                $this.find('button').toggleClass('color-swatch--active selected', is_swatch);
                $this.siblings().find('.selected').toggleClass('color-swatch--active selected', !is_swatch);
            } else {
                $this.removeClass('button--secondary').addClass('button--primary selected');
                $this.siblings('.button--primary.selected').removeClass('button--primary selected').addClass('button--secondary');
            }

            // Select current Product > Variant
            const $target = $this.closest(this.dom._card_content).find(`${this.dom._card_prod_options_var}[data-of="${$this.attr('for')}"]`)
            $target.removeClass('d-none');
            // hide other Product > Varaints
            $this.closest(this.dom._card_content).find(`${this.dom._card_prod_options_var}:not([data-of="${$this.attr('for')}"])`).addClass('d-none');

            // Trigger event
            const cache = JSON.parse($this.closest(this.dom._card_container).attr('data-cache'));
            const $previous = $target.find(`[data-val="${cache.last_selected_opt}"]`);
            ($previous.length ? $previous : $target.find('.selected[data-variant-id]')).trigger('click');

        });
        let tmp__callback = (e) => {

            let $this = $(e.currentTarget);

            if ($this.hasClass('color-swatch')) {
                $this.addClass('color-swatch--active selected');
                $this.closest('[data-el]').find('.color-swatch--active.selected').not($this).removeClass('color-swatch--active selected');
            } else {
                $this.removeClass('button--secondary').addClass('button--primary selected');
                $this.closest('[data-el]').find('.button--primary.selected').not($this).removeClass('button--primary selected').addClass('button--secondary');
            }
            $this.closest(this.dom._card_container).attr('data-cache', JSON.stringify({
                last_selected_opt: $this.data('val'),
            }));

            let vals = [];
            const $opts = $this.closest(this.dom._card_options).find('> div:not(.card__badges)');
            $opts.eq(0).length ? vals.push($opts.eq(0).find('.selected').data('val')) : null;
            $opts.eq(1).length ? vals.push($opts.eq(1).find('.selected').data('val')) : null;
            $opts.eq(2).length ? vals.push($opts.eq(2).find('.selected').data('val')) : null;
            const current_vals = this.get_variant__by_title(vals.join(' / '));

            // 2nd or 3rd option
            vals = [];
            $opts.eq(0).length ? vals.push($opts.eq(0).find('.selected').data('val')) : null;
            $opts.filter(':gt(0)').each((k, el) => {
                let first = true;
                const $opt = $(el);

                $opt.find('button[data-val]').each((k, btn) => {
                    const $btn = $(btn);
                    let v = vals;
                    v[$btn.data('option-index')] = $btn.data('val');

                    const variants = this.search_variant__by_opt(v);
                    $btn.toggle(!!variants.length);
                    if(variants.length && first && !current_vals) {
                        first = false;
                        if ($btn.hasClass('color-swatch')) {
                            $btn.addClass('color-swatch--active selected');
                            $btn.siblings('.color-swatch--active.selected').removeClass('color-swatch--active selected');
                        } else {
                            $btn.removeClass('button--secondary').addClass('button--primary selected');
                            $btn.siblings('.button--primary.selected').removeClass('button--primary selected').addClass('button--secondary');
                        }
                    }
                });

                const $current_opt = $opt.find('.selected')
                vals[$current_opt.data('option-index')] = $current_opt.data('val');
            });

            const selected_opts = [...$this.closest(this.dom._card_options).find('button.selected').map((k, btn) => $(btn).data('val'))].join(' / ');
            const variant = this.get_variant__by_id($this.data('variant-id')) || this.get_variant__by_title(selected_opts);

            $this.closest(this.dom._card_container).find(this.dom._card_var_title).text(selected_opts || variant.public_title || '');
            $this.closest(this.dom._card_container).find(this.dom._card_var_unavailable).toggleClass('d-none', variant.available);

            if (variant) {
                this.update_ui__card_price($this, variant);
            }
            
            this.update_ui__v2();
        };
        this.dom.$card_options.find('button[data-variant-id], button[data-val]').on('click', tmp__callback);
        this.dom.$card_options.each((k, el) => $(el).find('button[data-variant-id], button[data-val]').first().click());
        this.dom.$card_prod_options_var.find('button[data-variant-id], button[data-val]').on('click', tmp__callback);
        this.dom.$card_prod_options_var.each((k, el) => $(el).find('button[data-variant-id], button[data-val]').first().click());

        this.dom.$card_container.on('keyup change', this.dom._input_cart_properties, () => {
            this.draft_cart__update_list();
            this.update_ui__summary();
        });

        // INFO LINK CLICK
        this.dom.$card_title.find('a').on('click', (e) => {

            e.preventDefault();
            let $container = this.get_active_container();

            const img_formats = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
            const is_img = img_formats.includes(e.currentTarget.href.split('?').shift().split('.').pop());

            let content = '<iframe src="' + e.currentTarget.href + '"></iframe>';
            is_img && (content = '<img src="' + e.currentTarget.href + '" />');

            _WAL.SiteGlobal.modal('slide', {

                title: $container.data('bundle-index') ? this.data.bundle_items[$container.data('bundle-index')].group_name : this.current_product.type,
                body: content,
                large: true,
                dark_mode: true,

            });

        });

        // SHARE
        this.dom.$card_summary_share.on('click', (e) => {

            e.preventDefault();

            if (!this.draft_cart__user_validate()) { return; }

            _WAL.SiteGlobal.modal('slide', {

                //large: true,
                title: this.config.lang.share.title,
                description: this.config.lang.share.description,
                action: this.config.lang.share.action,
                body: `
                    <input type="email" class="field__input font-helvetica" value="${this.config.customer.email || ''}" />
                    <label class="field__label font-helvetica">Email</label>
                `,
                action_callback: ($modal) => {

                    const send_email = (append_cart = []) => {

                        let cart = this.draft_cart__prepare();
                        append_cart.forEach((item) => {
                            cart = cart.map(li => li.id == item.id ? { ...li, properties: { ...li.properties, ...item.properties } } : li);
                        });

                        return $.post({

                            url: this.aws.lightsail+'/api/product-share',
                            dataType: 'json',
                            data: {
                                e_to: $modal.find('input[type="email"]').val(),
                                e_title: this.config.lang.email.share_email_subject,                            
                                
                                cart_endpoint: window.location.origin+'/cart/add.js',
                                cart_email_layout: window.location.origin+'/cart?view=email-layout',
                                json_cart: JSON.stringify({ items: cart }),
                            }
    
                        }).then((res) => {
                            _WAL.SiteGlobal.modal('slide', {
                                title: this.config.lang.share.actioned,
                                description: res.message,
                            });
                        })
                        .fail((res) => {   
                            _WAL.SiteGlobal.modal('slide', {
                                title: '<span class="text-danger">Error</span>',
                                description: JSON.parse(res.responseText).message,
                            })
                        });

                    };

                    return _WAL.ProdEngraving.upload()
                        .then((res) => {
                            return send_email([
                                {
                                    id: (this.get_selected_var(_WAL.ProdEngraving.dom.$input)).id,
                                    properties: {"Preview": res.url}
                                }
                            ]);
                        })
                        .catch(() => {
                            return send_email();
                        });

                    const engraving_preview = _WAL.ProdEngraving?.to_img();
                    return (
                        engraving_preview && engraving_preview.then(() => {
                            return _WAL.ProdEngraving.upload()
                                .then((res) => {
                                    return send_email([
                                        {
                                            id: (this.get_selected_var(_WAL.ProdEngraving.dom.$input)).id,
                                            properties: {"Preview": res.url}
                                        }
                                    ]);
                                });
                        })
                    ) || send_email();

                },


            });

        });

        this.dom.$card_scrollable_ctrl.on('click', (e) => {
            const $this = $(e.currentTarget);
            const $target = $this.siblings('[data-el="product-configurator--scrollable"]');
            const el = $target.get(0);

            const next_scroll_pos = el.scrollLeft + el.clientWidth;
            const at_end = next_scroll_pos >= el.scrollWidth;

            el.scrollTo({
                left: at_end ? 0 : next_scroll_pos,
                behavior: "smooth",
            });
        });

        this.preselect();
    }

    loaded() {

        this.dom.$card_container
            .first()
            .find( this.dom._display_counter )
            .text( (1).toLocal( this.current_store ) );

    }

    get_selected_var($el, return_selected_el = false) {

        let $container = $el ? $($el).closest(this.dom._card_container) : this.dom.$card_container.first();
        let $content = $container ? $container.find(this.dom._card_content) : $container;
        let $target = $content.find('.selected[data-variant-id]').first();

        if ($content.find(this.dom._card_prod_options_var).length) {
            $target = $content.find(`${this.dom._card_prod_options} input:checked`);
            $target = $content.find(`${this.dom._card_prod_options_var}[data-of="${$target.attr('id')}"] .selected`).first();
        }

        if (return_selected_el) {
            return $target;

        } else {

            if ($target.data('variant-id')) {
                return this.get_variant__by_id($target.data('variant-id'));

            } else {
                let values = [];
                $content.find(`${this.dom._card_options} .selected`).map((k, el) => {
                    values.push(el.dataset.val?.replace('[dq]', '"'));
                });
                return this.get_variant__by_title(values.join(' / '), $container.data('prod-handles')?.split(','));
            }
        }
    }

    get_active_container(visible_cards_only = true) {
        //return this.dom.$card_container.filter(':not([data-prod-handles*="engraving"], .d-none)').filter((k, el) => {
        /*
            - NOT .d-none (controlled by ProdConfig Class)
            - Input NOT :checked (controlled by user)
            - Style display: none; (controlled by SiteProdCompatibility)
        */
        
        const $containers = this.dom.$card_container.filter((k, el) => {
            let $this = $(el);
            const is_checked = $this.find(`${this.dom._card_title} input`).is(':checked');
            const is_displayed = window.getComputedStyle(el).display !== 'none'
            return !(!is_checked || !is_displayed);
        });

        return visible_cards_only ? $containers : $.merge(
            $containers,
            this.dom.$card_container.filter((k, el) => {
                const $this = $(el);
                const bundle_item = this.data.bundle_items[parseInt($this.data('bundle-index'))];

                if(!bundle_item) { return; }

                const cart_skus = Object.values(this.draft_cart).map((cart_item) => cart_item.variant.sku);
                const is_considered_active = bundle_item.prerequisite.length > 0 && cart_skus.filter(v => bundle_item.prerequisite.includes(v)).length > 0;
                return $this.is('.visually-hidden') && is_considered_active;
            })
        ).sort((a, b) => ($(a).index() - $(b).index()));

    }

    get_variant__by_id(key = '', handles) {
        return this.data.bundle_items.flatMap(r => r.options).concat(this.data.product.variants).reverse().filter(v => (
            v.id == key
            && (handles ? handles.includes(v.product.handle) : true)
        ))[0] || false;
    }

    get_variant__by_title(key = '', handles) {
        return this.data.bundle_items.flatMap(r => r.options).concat(this.data.product.variants).reverse().filter(v => (
            v.public_title == key
            && (handles ? handles.includes(v.product.handle) : true)
        ))[0] || false;
    }

    get_variant__by_sku(key = '', handles) {
        return this.data.bundle_items.flatMap(r => r.options).concat(this.data.product.variants).reverse().filter(v => (
            v.sku == key
            && (handles ? handles.includes(v.product.handle) : true)
        ))[0] || false;
    }

    search_variant__by_opt(opts = []) {
        return this.data.bundle_items.flatMap(r => r.options).concat(this.data.product.variants).filter(v => {
            let included = true;
            opts.forEach((opt, i) => {
                if (v.options[i] != opt) {
                    included = false;
                }
            });
            return included;
        });
    }

    load_engraving_img(skus = []) {

        if(!skus.length) { return; }

        const active_container = this.get_active_container();
        active_container.each((index, el) => {
            
            const $this = $(el);
            const $img = $this.find(this.dom._card_image);

            if(!$this.is(this.dom._card_engraving_type)) { return true; }

            let dir = `products-3.0/${this.current_product.handle}/web/`;

            this.aws.has(dir).then((dir) => {
                
                // console.log('Products 3.0 ENGRAVING IMG', dir);
                // Products-3.0 Supports 1 or 2 SKUs in PNG only

                this.aws.has(`${dir+skus[0]}.png`)
                .then((img_url) => this.helper.img.load( $img, img_url ))
                .catch((img_url) => {
                    this.aws.has(`${dir+skus[0]}--${skus[1]}.png`)
                    .then((img_url) => this.helper.img.load( $img, img_url ))
                    .catch((img_url) => this.helper.img.load($img, this.config.placeholder.image));
                });


            }).catch((err) => {
                // console.log('Products 2.0 ENGRAVING IMG');
                /* #################################################################################### */
                /* BACKWARD COMPATIBILITY ############################################################# */
                /* #################################################################################### */

                // Products-2.0 Supports 1 or 2 SKUs in PNG or JPG

                dir = `products-2.0/${this.current_product.handle}/web/`;
            
                // Load JPG
                this.aws.has(`${dir+skus[0]}.jpg`)
                .then((img_url) => this.helper.img.load( $img, img_url ))
                .catch((img_url) => {

                    // Load PNG
                    this.aws.has(`${dir+skus[0]}.png`)
                    .then((png_img_url) => this.helper.img.load( $img, png_img_url ))
                    .catch((img_url) => {
                        
                        // Otherwise search for first addon product with engraving settings (i.e Shifter as addon)
                        const cart_item = Object.keys(this.draft_cart)
                            .filter((h) => h != this.current_product.handle && this.draft_cart[h].variant.product.metafields?.engraving)
                            .map(h => this.draft_cart[h])
                            [0] || {};
                        
                        if( cart_item.id ) {
                            const img_path = `products-2.0/${cart_item.variant.product.handle}/web/${cart_item.variant.sku}.png`;
                            this.aws.has(img_path).then((img_url) => {
                                this.helper.img.load( $container.find(this.dom._card_image), img_url );
                                WAL_Apploader.register('ProdEngraving', () => {
                                    window._WAL.ProdEngraving.apply_config(cart_item.variant.product.metafields.engraving);
                                });
                            }).catch(() => {});

                        } else {
                            this.load_engraving_img__v2();
                        }

                    });
                });
                /* #################################################################################### */
                /* #################################################################################### */
                /* #################################################################################### */
            });
        });

        WAL_Apploader.register('ProdEngraving', () => {
            //console.log('Loading settings for', this.draft_cart[this.data.product.handle].variant.title, this.config.engraving[this.draft_cart[this.data.product.handle].id]);
            window._WAL.ProdEngraving.apply_config( this.config.engraving[this.draft_cart[this.data.product.handle].id] );
            
            this.url.get_param('logger') == 'engraving' && this.log_html({html: `<h3><pre>Engraving for ${this.draft_cart[this.data.product.handle].variant.title}:</pre></h3><pre>${
                JSON.stringify( this.config.engraving[this.draft_cart[this.data.product.handle].id], null, 2 ).replaceAll('"', '')
            }</pre>`, width: 400});
        });
    }

    load_engraving_img__v2(img_skus = []) {
        // !!! This is used to extned the load_engraving_img method

        // If all cards are already loaded, return
        if(this.get_active_container().length == img_skus.length) { return; }

        const next_sku = (index) => {
            const cards = this.get_active_container().filter((k, el) => {
        
                const $this = $(el);
                const item = this.data.bundle_items[parseInt($this.data('bundle-index'))];
                
                // Ignore optional cards
                if(!item?.is_required) { return false; }
                
                // Ignore engraving type cards
                if($this.is(this.dom._card_engraving_type) && $this.find(this.dom._input_cart_properties).length) { return false; }

                return true;
            });
            
            return this.get_selected_var( cards[index] )?.sku;
        };

        img_skus.push( next_sku(img_skus.length) );

        const img_url = ['products-2.0', this.current_product.handle, 'web', img_skus.join('--')].join('/') + '.jpg';
        this.dom.$card_container.filter(this.dom._card_engraving_type).each((k, el) => {
            const $container = $(el);
            if(!$container.find(this.dom._input_cart_properties).length) { return; }

            this.aws.has(img_url).then((img_url) => {
                this.helper.img.load( $container.find(this.dom._card_image), img_url );
            }).catch(() => {
                this.load_engraving_img__v2(img_skus);
            });
        });
    }

    load_prod_preview_img(img_skus = []) {

        const $first_image = this.dom.$product_preview.find(this.dom._card_image).first();
        const img_selector = this.dom._card_image.replace(/[\[\]']+/g, '');
        const dir = `products-3.0/${this.current_product.handle}/summary/`;
        const img_rules = this.config.product_preview_image_rules || [];

        this.aws.has(dir).then((dir) => {
            $first_image.attr('data-display', 'upgraded');
            $first_image.siblings(this.dom._card_image).attr('data-to-be-removed', 'true');

            this.cache.required_prod_imgs = []; // for debuging only

            this.get_active_container().each((k, el) => {

                const $this = $(el);
                const item = this.data.bundle_items[parseInt($this.data('bundle-index'))];

                // Ignore optional cards
                if(!item?.is_required) { return false; }
                // Ignore engraving type cards
                if($this.is(this.dom._card_engraving_type) && $this.find(this.dom._input_cart_properties).length) { return false; }
                
                const variant = this.get_selected_var( $this );

                let suffix = '';
                img_rules.forEach((rule, x) => {
                    /* Check selected SKUs. Possible prerequisite_skus values:
                        - "SKU1"
                        - "SKU1, SKU2, SKU3" (all SKUs must be in the cart)
                    ========================================================= */
                    const selected_skus = rule.prerequisite_skus.filter(r => {
                        r = r.replaceAll(', ', ',').replaceAll(' ,', ',').trim(); // cleanup string
                        if(r.includes(',')) {
                            return r.split(',').every(s => img_skus.includes(s));
                        } else {
                            return img_skus.includes(r);
                        }
                    });
                    if(selected_skus.length && rule.target_skus.includes(variant.sku)) {
                        suffix = rule.suffix;
                    }
                });
                const url = `${dir+variant.sku}${suffix && '--' + suffix}.png`;

                // DEBUG
                this.cache.required_prod_imgs.push(url);

                const $img = $first_image.siblings(this.dom._card_image+`[data-index="${k}"]`);
                if($img.length) {
                    $img.removeAttr('data-to-be-removed');
                    
                    if(!$img.attr('src').includes(url)) {
                        //$img.attr('data-loading', 'true'); // --> This adds a loading animation. Disabled by client's request.

                        const preloader = new Image();
                        preloader.onload = () => {
                            $img.attr('src', url);
                            //setTimeout(() => $img.removeAttr('data-loading'), 1200);
                        };
                        preloader.onerror = () => {
                            $img.remove();
                            //console.error("Failed to load image:", url);
                        };
                        preloader.src = url;
                    }

                } else {
                    $first_image.after(`<img
                        class="w-100 ratio ratio-1x1"
                        width="auto"
                        height="auto"
                        ${img_selector} src="${url}"
                        data-index="${k}"
                        style="z-index: ${k};"
                        onload="this.style.display='block';"
                        onerror="if(this.src.includes('.png')) { this.src = this.src.replace('.png', '.gif'); } else { this.remove(); }"
                    />`);
                }
                $first_image.siblings(this.dom._card_image+'[data-to-be-removed="true"]').remove();

            });

            // Logger via iframe srcdoc
            this.url.get_param('logger') == 'quick-preview' && this.log_html({html: `<h3><pre>Quick Preview Images:</pre></h3><pre>${
                this.cache.required_prod_imgs.join('\n')
                    .replaceAll(dir, '')
                    .replaceAll('.png', '')
                    .replaceAll('.jpg', '')
                    .replaceAll('.jpeg', '')
                    .replaceAll('.gif', '')
            }</pre>`});

            this.render_draft_summary_img(this.cache.required_prod_imgs);

        }).catch((err) => {
            // this.dom.$product_preview.hide();

            /* #################################################################################### */
            /* BACKWARD COMPATIBILITY ############################################################# */
            /* #################################################################################### */
            const img_path = `products-2.0/${this.current_product.handle}/summary/${img_skus.join('--')}.gif`;
            const summary_imgs = this.dom.$card_summary_img_container.find('img');

            // Load GIF
            this.dom.$product_preview.show();
            this.aws
            .has(img_path)
            .then((img_url) => {
                this.helper.img.load( this.dom.$product_preview.find(this.dom._card_image), img_url );
                this.helper.img.load( summary_imgs.first(), img_url );
                summary_imgs.slice(1, img_skus.length).hide();

                this.cache.required_prod_imgs = [`${img_skus.join('--')}.gif`];
            })
            .catch((img_url) => {

                // Otherwise load PNG
                this.aws
                .has(img_url.replace('.gif', '.png'))
                .then((png_img_url) => {
                    this.helper.img.load( this.dom.$product_preview.find(this.dom._card_image), png_img_url );
                    this.helper.img.load( summary_imgs.first(), png_img_url );
                    summary_imgs.slice(1, img_skus.length).hide();

                    this.cache.required_prod_imgs = [`${img_skus.join('--')}.png`];
                })
                .catch((img_url) => {
                    this.aws
                    .has(img_url.replace('.png', '.jpg'))
                    .then((jpg_img_url) => {
                        this.helper.img.load( this.dom.$product_preview.find(this.dom._card_image), jpg_img_url );
                        this.helper.img.load( summary_imgs.first(), jpg_img_url );
                        summary_imgs.slice(1, img_skus.length).hide();

                        this.cache.required_prod_imgs = [`${img_skus.join('--')}.jpg`];
                    })
                    .catch((img_url) => {
                        img_skus.pop();
                        img_skus.length
                            ? this.load_prod_preview_img(img_skus)
                            : this.dom.$product_preview.hide();
                    });

                });
            });
            /* #################################################################################### */
            /* #################################################################################### */
            /* #################################################################################### */
        });
    }

    render_draft_summary_text($tmpl = false) {

        // RESET SUMMARY
        this.dom.$card_summary.find('*:not(template)').remove();

        let selected_total = 0;
        const template = (!$tmpl ? this.dom.$card_summary.find('template') : $tmpl).html();

        let html = '';
        let index = 0;
        for (let key in this.draft_cart) {
            const cart_item = this.draft_cart[key];
            const v = this.get_variant__by_id(cart_item.id);
            selected_total += cart_item.prop._free || cart_item.prop._bundle_type ? 0 : v.price;
            let content = v.available ? `<span data-el-val="${v.title}">${v.title}</span>` : `<span data-el-val="${v.title}"><s>${v.title}</s><br /><small>(${this.config.lang.product.sold_out})</small></span>`;
            for (let k in cart_item.prop) {
                const is_allowed_hidden_prop = k.includes('_Engraving') || k.includes('_Text');
                if (k[0] == '_' && !is_allowed_hidden_prop) { continue; }
                const prop = cart_item.prop[k];
                content += `<span data-el-val="${prop}">${k.replace('_', '')}: ${prop}</span>`;

            }
            html += this.compile_html(template, {
                heading: v.product?.title,
                content: content,
                img_url: (v.featured_image?.src || v.product?.featured_image || '').split('?')[0],
            });
            index++;
        }
        // Set total
        html += `<div class="h1 font-helvetica mt-5 mb-0">${this.config.lang.product.total + Shopify.formatMoney(selected_total, this.config.money_format)}</div>`;

        // RENDER SUMMARY TEXT
        this.dom.$card_summary.append( html );

        return html;
    }

    render_draft_summary_img(required_prod_imgs = []) {

        // CLEAN UP EXTRA IMAGES
        this.dom.$card_summary_img_container.find(`img:gt(${this.get_active_container().length-1})`).remove();

        // RENDER SUMMARY IMAGES
        this.get_active_container().each((k, el) => {
            const $this = $(el);
            const variant = this.get_selected_var( $this );

            let $img = this.dom.$card_summary_img_container.find('img').eq(k);
            if(!$img.length) {
                $img = this.dom.$card_summary_img_container.find('img:first-child').clone();
                this.dom.$card_summary_img_container.append( $img );
            }

            const img_src = required_prod_imgs[k] || (variant.featured_image?.src || variant.product?.featured_image || this.config.placeholder.image || '') + '&width=500';
            this.helper.img.load( $img, img_src ); // Set attr
        });

        // CREATE WRAPPER IF REQUIRED
        let $img_wrapper = this.dom.$card_summary_img_container.find('[data-upgraded]');
        $img_wrapper.length && this.dom.$card_summary_img_container
            .find('[data-upgraded] img')
            .unwrap()
        ;
        required_prod_imgs.length && this.dom.$card_summary_img_container
            .find('img:lt('+required_prod_imgs.length+')')
            .wrapAll('<div data-upgraded class="col-2" />')
        ;
    }

    update_ui__summary() {
        // RENDER SUMMARY TEXT
        this.render_draft_summary_text();

        // RENDER SUMMARY IMAGES
        this.render_draft_summary_img(this.cache.required_prod_imgs);
    }

    update_ui__card_price($card, v) {

        $card = $card.closest(this.dom._card_container);
        let price = v.price;
        let compare_at_price = v.compare_at_price;

        // Bundle products
        if(v.sku?.includes('--')) {
            v.sku.split('--').forEach(sku => {
                const _v = this.get_variant__by_sku(sku);
                price += _v.price;
                compare_at_price += _v.compare_at_price;
            });
        }
        
        const isOnSale = compare_at_price > 0;
        const discount = Math.round((((price / (compare_at_price || 0)) * 100) - 100) * -1);

        // Discount % badge
        $card
            .find(this.dom._card_discount_badge)
            .text(this.config.lang.product.discount.replace('{{ ', '{{').replace(' }}', '}}').replace('{{value}}', discount+'%'))
            .toggle(discount > 0);

        // Compare at price
        const $price_container = $card.find(this.dom._card_compare_at_price).parent();
        $price_container.attr('class', isOnSale ? $price_container.data('class-fullwidth') : $price_container.data('class-default'))
        $card
            .find(this.dom._card_compare_at_price)
            .text(Shopify.formatMoney(compare_at_price, this.config.money_format))
            .toggleClass('d-none', !isOnSale);

        // Main price
        const isMainProd = v.product?.handle == this.data.product.handle;
        $card
            .find(this.dom._card_price)
            .text(Shopify.formatMoney(price,
                (!isOnSale ? '' : this.config.lang.product.on_sale + ' ') +
                (isMainProd ? '' : '+' ) +
                this.config.money_format
            ))
            .toggle(price > 0 || discount > 0);
    }

    update_ui() {

        // UPDATE CARD
        let card_counter = this.data.product.variants.length == 1 && this.data.product.price == 0 ? 0 : 1;
        this.data.bundle_items.forEach((bundle_item, bundle_index) => {

            //if (bundle_item.prerequisite.length == 0) { return; }

            // conditional display
            const cart_skus = Object.values(this.draft_cart).map((cart_item) => {
                return (this.get_variant__by_id(cart_item.id)).sku;
            });

            const handles = [...new Set(Object.values(bundle_item.option_products).map(x => x.handle))].join(',');
            const is_card_hidden = bundle_item.prerequisite.length > 0 && cart_skus.filter(v => bundle_item.prerequisite.includes(v)).length == 0;

            if (!is_card_hidden && bundle_item.has_image) {
                this.dom.$card_container
                    .filter(`[data-bundle-index^="${bundle_index}"]`)
                    .find(this.dom._display_counter)
                    .text( (++card_counter).toLocal( this.current_store ) );
            }

            this.dom.$card_container.filter(`[data-bundle-index^="${bundle_index}"]`)
                .attr('data-bundle-index-ui', (!is_card_hidden && bundle_item.has_image) ? card_counter : '#')
                .toggleClass('d-none', is_card_hidden)
                .toggleClass('visually-hidden', !bundle_item.has_image);
        });

        this.dom.$card_divider.toggleClass('d-none', !this.dom.$card_divider.nextAll(this.dom._card_container+':not(.d-none)').length);

        const active_container = this.get_active_container();

        // UPDATE CONFIG CARDS
        active_container.each((key, el) => {
            let $this = $(el);
            const bundle = this.data.bundle_items[parseInt($this.data('bundle-index'))];

            if(bundle && !bundle.has_image) { return true; }

            const variant = this.get_selected_var($this);

            if(!variant) { return true; }

            //CTA Button
            const isAvailable = variant.available && (variant.product.tags.filter(x => x.dashcase() == this.config.coming_soon_tag).length == 0);
            $this.find(`${this.dom._card_next_add_btn}:not([data-bis])`).prop('disabled', !isAvailable);
            $this.find(`${this.dom._card_next_add_btn}`).attr('data-disabled', !isAvailable);
            const avail_label = $this.find(`${this.dom._card_next_add_btn} [data-availability="true"]`);
            avail_label.toggleClass('d-none', !isAvailable).text(active_container.length == (key+1) ? avail_label.data('review') : avail_label.data('next'));
            $this.find(`${this.dom._card_next_add_btn} [data-availability="false"]`).toggleClass('d-none', !!isAvailable);

            //Price
            this.update_ui__card_price($this, {...variant, ...{price: bundle?.is_free ? 0 : variant.price}});

            //Badge
            this.dom.$card_badges.find('[data-badge="'+variant.id+'"]').show().siblings().hide();

            //Badge icon on options
            if($this.index() !== 0) {return;} // TO BE REMOVED AFTER TESTING
            const vars = bundle ? bundle.options : variant.product.variants;
            const selected_opts = [...$this.find(this.dom._card_options).find('button.selected').map((k, btn) => $(btn).data('val'))];
            const $last_opts = $this.find(this.dom._card_options + ' > div:last-child');
            const last_opts_index = $last_opts.index() / 2 - ($this.index() == 0 ? 0 : 1);
            const has_badge_in_opt1 = $this.find('[data-badge="true"][data-option-index="0"]').length > 0;
            
            selected_opts.length > 1 && $last_opts.find('button').each((k, el) => {
                const $btn = $(el);
                const this_opts = selected_opts;
                this_opts[last_opts_index] = $btn.data('val');
                const this_badge = this.find_variant(this_opts.join(' / '), vars)?.metafields?.badge;
                /*
                    data-badge="true"
                    style="
                        --badge-icon: url(//fonts.gstatic.com/s/e/notoemoji/latest/{{ badge_emoji | remove_first: 'u' }}/512.gif);
                        --badge-bg: {{ badge_background }};
                    "
                */
                // this_badge && console.log(selected_opts, this_opts);

                // Toggle only if it's NOT already shown by the first option
                if(this_badge && !has_badge_in_opt1) {
                    $btn.attr('data-badge', 'true');
                    $btn.css({
                        '--badge-icon': `url(//fonts.gstatic.com/s/e/notoemoji/latest/${this_badge.badge_emoji.replace('u', '')}/512.gif)`,
                        '--badge-bg': this_badge.badge_background,
                    });
                } else {
                    $btn.removeAttr('data-badge');
                    $btn.css({
                        '--badge-icon': '',
                        '--badge-bg': '',
                    });
                }
            });
            //variant.metafields.badge && console.log('VARIANT', variant.metafields.badge);
            
        });

        // UPDATE CARD IMAGE
        const img_skus = [];
        active_container.each((index, el) => {
            
            const $this = $(el);
            const bundle_index = $this.data('bundle-index');
            const bundle_item = this.data.bundle_items[bundle_index];

            const variant = this.get_selected_var( $this );
            img_skus.push( variant.sku || '' );

            if($this.is(this.dom._card_engraving_type) && $this.find(this.dom._input_cart_properties).length) { return false; }

            // Basic Product Images
            if(!bundle_item?.is_required) {
                variant && this.helper.img.load(
                    //$this.closest(this.dom._card_container).find(this.dom._card_image),
                    $this.find(this.dom._card_image),
                    (variant.featured_image && variant.featured_image.src+'&width=500') || this.config.placeholder.image
                );
                return true;
            }
            
            // Stacked Product Images
            const $first_image = $this.find(this.dom._card_image).first();

            const img_selector = this.dom._card_image.replace(/[\[\]']+/g, '');
            const dir = `products-3.0/${this.current_product.handle}/${bundle_index}/`;

            this.aws.has(dir).then((dir) => {
            
                $first_image.attr('data-display', 'upgraded');
                $first_image.siblings(this.dom._card_image).attr('data-to-be-removed', 'true');
                img_skus.forEach((sku, k) => {
                    let suffix = '';
                    bundle_item.image_rules.forEach((rule, x) => {
                        /* Check selected SKUs. Possible prerequisite_skus values:
                            - "SKU1"
                            - "SKU1, SKU2, SKU3" (all SKUs must be in the cart)
                        ========================================================= */
                        const selected_skus = rule.prerequisite_skus.filter(r => {
                            r = r.replaceAll(', ', ',').replaceAll(' ,', ',').trim(); // cleanup string
                            if(r.includes(',')) {
                                return r.split(',').every(s => img_skus.includes(s));
                            } else {
                                return img_skus.includes(r);
                            }
                        });
                        if(selected_skus.length && rule.target_skus.includes(sku)) {
                            suffix = rule.suffix;
                        }
                    });
                    const url = `${dir+sku}${suffix && '--' + suffix}.png`;

                    const $img = $first_image.siblings(this.dom._card_image+`[data-index="${k}"]`);
                    if($img.length) {
                        $img.removeAttr('data-to-be-removed');
                        
                        if(!$img.attr('src').includes(url)) {
                            //$img.attr('data-loading', 'true'); // --> This adds a loading animation. Disabled by client's request.

                            const preloader = new Image();
                            preloader.onload = () => {
                                $img.attr('src', url);
                                //setTimeout(() => $img.removeAttr('data-loading'), 1200);
                            };
                            preloader.onerror = () => {
                                $img.remove();
                                //console.error("Failed to load image:", url);
                            };
                            preloader.src = url;
                        }

                    } else {
                        $first_image.after(`<img
                            width="300" height="300" ${img_selector} src="${url}"
                            data-index="${k}"
                            style="z-index: ${k};"
                            onload="this.style.display='block';"
                            onerror="if(this.src.includes('.png')) { this.src = this.src.replace('.png', '.gif'); } else { this.remove(); }"
                        />`);
                    }
                });
                $first_image.siblings(this.dom._card_image+'[data-to-be-removed="true"]').remove();

            }).catch((err) => {
                $first_image.attr('data-display', 'default');
            
                /* #################################################################################### */
                /* BACKWARD COMPATIBILITY ############################################################# */
                /* #################################################################################### */
                const skus = img_skus.slice(0, index+1); // limit the SKUs to the nth as this is a async function
                const img_path = `products-2.0/${this.current_product.handle}/${skus.join('--')}.gif`;
            
                // Load GIF
                this.aws
                .has(img_path)
                .then((img_url) => {
                    this.helper.img.load( $this.find(this.dom._card_image), img_url );
                })
                .catch((img_url) => {

                    // Otherwise load PNG
                    this.aws
                    .has(img_url.replace('.gif', '.png'))
                    .then((png_img_url) => {
                        this.helper.img.load( $this.find(this.dom._card_image), png_img_url );
                    })
                    .catch((img_url) => {
                        
                        this.aws
                        .has(img_url.replace('.png', '.jpg'))
                        .then((jpg_img_url) => {
                            this.helper.img.load( $this.find(this.dom._card_image), jpg_img_url );
                        })
                        .catch((img_url) => {
                            // Load either Shopify varaint image or default placeholder
                            variant && this.helper.img.load(
                                //$this.closest(this.dom._card_container).find(this.dom._card_image),
                                $this.find(this.dom._card_image),
                                (variant.featured_image && variant.featured_image.src+'&width=500') || this.config.placeholder.image
                            );
                        });

                    });
                });
                /* #################################################################################### */
                /* #################################################################################### */
                /* #################################################################################### */

            });
        });

        // UPDATE PREVIEW IMAGE
        this.load_prod_preview_img(img_skus);
        
        // UPDATE ENGRAVING IMAGE
        this.load_engraving_img(img_skus);

        // UPDATE SUMMARY
        this.update_ui__summary();

        // ADD TO CART
        const selectedMainVar = this.get_variant__by_id(this.draft_cart[this.data.product.handle].id);
        const isAvailable = selectedMainVar.available && (selectedMainVar.product.tags.filter(x => x.dashcase() == this.config.coming_soon_tag).length == 0);
        this.dom.$btn_add_to_cart.prop('disabled', !isAvailable); // main prod only
        //this.dom.$btn_add_to_cart.prop('disabled', !!Object.values(this.draft_cart).filter((i) => !i.variant.available).length); // all prod check

        if( this.dom.$btn_add_to_cart.is('[data-last-added="'+Object.values(this.draft_cart).map(i => i.id).join('-')+'"]' ) ) {
            this.dom.$btn_add_to_cart_added.removeClass('d-none');
            this.dom.$btn_add_to_cart_added.siblings().addClass('d-none');
        } else {
            this.dom.$btn_add_to_cart_init.removeClass('d-none');
            this.dom.$btn_add_to_cart_init.siblings().addClass('d-none');
        }
    }

    update_ui__v2() {
        /* !!! Important: This is a bit of a patch fix. ================
        Some of the logics in the draft_cart__update_list() relies
        on some "visibility" values that are set in the update_ui(),
        but the update_ui() also relies on the content of the draft_cart,
        so we need to call these two functions twice.
        ================================================================= */
        this.draft_cart__update_list();
        this.update_ui();

        this.draft_cart__update_list();
        this.update_ui();
    }

    is_engraving_card(context) {
        return $(context).closest(this.dom._card_container).is(this.dom._card_engraving_type);
    }

    draft_cart__update_list() {

        this.draft_cart = [];

        //MAIN PROD
        let values = [];
        this.dom.$card_container.filter(`[data-prod-handles="${this.data.product.handle}"]`).find(this.dom._card_options).find('.selected').map((k, el) => { values.push(el.dataset.val.replace('[dq]', '"')); });
        const main_var = this.get_variant__by_title(values.join(' / '));
        this.draft_cart[this.data.product.handle] = { id: main_var.id, prop: {}, variant: main_var, is_required: false };

        // UPDATE CARD
        this.get_active_container(false).each((key, el) => {

            let $this = $(el);
            let __is_valid = true;
            let cart_handle = 'index-'+key;

            const is_card_visibly_hidden = $this.is('.visually-hidden');
            const bundle = this.data.bundle_items[parseInt($this.data('bundle-index'))];

            let variant = this.get_selected_var($this);

            if(!variant) { return true; }

            let prop = {_label: (bundle?.block_title || variant.product.title)};

            // SET ADDITIONAL PROPERTIES
            $this.find(this.dom._input_cart_properties).each((k, input) => {

                let $input = $(input);
                const prop_name = (this.is_engraving_card($this) ? '_' : '') + $input.attr('name');
                if ($input.val().trim() != '') { prop[prop_name] = $input.val().trim(); }

                //if ($input.is('[required]') && $input.val().trim() == '') { __is_valid = false; }

            });

            // SET "FREE" FLAG
            bundle?.is_free && (prop._bundle_type = 'FREE');

            // SET PREREQUISITE in properties
            if (bundle?.prerequisite.length) {
                const cart_skus = Object.values(this.draft_cart).map(i => i.variant.sku);
                //prop._prerequisite = bundle.prerequisite.join(',');
                //prop._prerequisite = bundle.prerequisite.filter(Set.prototype.has, new Set(cart_skus)).join(',');
                prop._prerequisite = bundle.prerequisite.filter(sku => cart_skus.includes(sku)).join(',');
            }

            if (!__is_valid || (bundle?.prerequisite.length && is_card_visibly_hidden)) { return true; }

            // Add main product
            if(variant) {
                cart_handle = _WAL.ProdEngraving?.is_engraving(el) || this.data.product.handle == variant.product.handle ? variant.product.handle : cart_handle;
                this.draft_cart[cart_handle] = { id: variant.id, prop: prop, variant: variant, is_required: (bundle?.is_required || false) };
            }
            
            // Add bundle producs using the main's product SKU
            variant?.sku?.includes('--') && variant?.sku.split('--').forEach((sku, k) => {
                const v = this.get_variant__by_sku(sku);
                v && (this.draft_cart[cart_handle+'-'+k] = { id: v.id, prop: {}, variant: v, is_required: true });
            });
        });
    }

    draft_cart__user_validate() {

        let __is_valid = true;

        this.get_active_container().each((key, el) => {

            let $this = $(el);

            // check required input
            $this.find(this.dom._input_cart_properties).each((k, input) => {

                let $input = $(input);
                if ($input.is('[required]') && $input.val().trim() == '') {
                    __is_valid = false;
                    $input.addClass('is-invalid').attr('placeholder', $input.data('invalid-placeholder'));
                }

            });


            if (!__is_valid || !this.get_selected_var($this).available ) {
                __is_valid = false;
                $([document.documentElement, document.body]).animate({
                    scrollTop: $this.offset().top - $('.section-header').height() + 50
                }, 500, 'linear');
                return false;
            }

        });

        return __is_valid;
    }

    draft_cart__add(e) {

        // FRONT-END VALIDATE
        if (!this.draft_cart__user_validate()) { return; }

        this.dom.$btn_add_to_cart.prop('disabled', true);
        this.dom.$btn_add_to_cart_loading.removeClass('d-none');
        this.dom.$btn_add_to_cart_loading.siblings().addClass('d-none');

        const add_to_cart = () => {
            return _WAL.SiteCart.func.add( this.draft_cart__prepare() )
                .then(() => {
                    this.dom.$btn_add_to_cart.attr('data-last-added', Object.values(this.draft_cart).map(i => i.id).join('-'));
                    this.dom.$btn_add_to_cart_added.removeClass('d-none');
                    this.dom.$btn_add_to_cart_added.siblings().addClass('d-none');
                })
                .fail(() => {
                    this.dom.$btn_add_to_cart_init.removeClass('d-none');
                    this.dom.$btn_add_to_cart_init.siblings().addClass('d-none');
                })
                .always(() => {
                    this.dom.$btn_add_to_cart.prop('disabled', false);
                });
        };

        return _WAL.ProdEngraving.upload()
            .then((res) => {
                const engraving_product_handle = _WAL.ProdEngraving.product_handle;
                if (engraving_product_handle && this.draft_cart[engraving_product_handle]) {
                    this.draft_cart[engraving_product_handle].prop['Preview'] = res.url;
                }
            })
            .finally(add_to_cart);

    }

    draft_cart__prepare() {
        const group_id = (Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)).toString();
        return Object.values(this.draft_cart).reverse().map(cart_item => {

            return {
                quantity: 1,
                id: cart_item.id,
                properties: (() => {
                    let prop = { _group: group_id }
                    if (cart_item.variant.product.handle == this.data.product.handle) { prop._group = '#' + prop._group; }
                    else if (cart_item.is_required) { prop._group = '*' + prop._group; }
                    else { prop._group = '+' + prop._group; }

                    return { ...cart_item.prop, ...prop };
                })(),
            };

        })
    }

    preselect() {

        WAL_Apploader.register('SiteProdCompatibility', () => {

            _WAL.SiteProdCompatibility.get_compatible_prods(true).then((compatible_prods) => {

                if (compatible_prods.length) {
    
                    compatible_prods.forEach((prod_handle, index) => {
                        prod_handle = prod_handle.split('::');
    
                        let $container = this.dom.$card_container.filter('[data-prod-handles*="' + prod_handle[0] + '"]');
    
                        var $input = $container.find(this.dom._card_title + ' input[type="checkbox"]');
                        $input.prop('checked', true);
                        $input.trigger('change');
    
                        if (prod_handle.length == 2) { // --> key[0]:val[1]
                           
                            let matched_var = $container
                                .find([this.dom._card_options, this.dom._card_prod_options_var].join(', '))
                                .find('button')
                                .filter((k, el) => {
                                    const niddle = prod_handle[1].replaceAll('”', '"');
                                    const haystack = el.innerHTML.replaceAll('”', '"');
                                    return haystack.includes(niddle);
                                });
    
                            if (matched_var.length == 1) {
    
                                let $btn = $(matched_var[0]);
    
                                if($container.is(':first-child')) {
                                    $btn.siblings().addClass('d-none');
                                }
    
                                // input
                                $container
                                    .find(this.dom._card_prod_options)
                                    .find('input[id="' + $btn.closest(this.dom._card_prod_options_var).data('of') + '"]')
                                    .prop('checked', true)
                                    ;
    
                                // label - BTN
                                $container
                                    .find(this.dom._card_prod_options+':not('+this.dom._card_prod_options_swatch+')')
                                    .addClass('d-none')
                                    .find('[for="' + $btn.closest(this.dom._card_prod_options_var).data('of') + '"]')
                                    .removeClass('d-none button--secondary')
                                    .addClass('button--primary selected')
                                    .siblings()
                                    .removeClass('button--primary selected')
                                    .addClass('d-none button--secondary')
                                    ;

                                // label - SWATCH
                                $container
                                    .find(this.dom._card_prod_options+this.dom._card_prod_options_swatch+' [for="' + $btn.closest(this.dom._card_prod_options_var).data('of') + '"]')
                                    .addClass('selected')
                                    .siblings()
                                    .removeClass('selected')
                                    ;
    
                                $container.find(this.dom._card_prod_options_var).addClass('d-none');
                                
                                $btn.trigger('click').trigger('click');
    
                                $container.find(this.dom._card_info + '[data-view="default"]').hide();
                                $container.find(this.dom._card_info + '[data-view="preselect"]').show();
    
                            } else {
    
                                $container.find(this.dom._card_card).addClass('p-4').removeClass('ps-4 pe-4 pb-4 pt-5');
                                $container.find(this.dom._card_info + '[data-view="default"]').hide();
    
                            }
                        }
                    });
    
                } else {
    
                    this.dom.$card_container.each((k, el) => {
    
                        let $container = $(el);
    
                        // Show all product selector
                        $container
                            .find(this.dom._card_prod_options+':not('+this.dom._card_prod_options_swatch+')')
                            .removeClass('d-none')
                            .find('[for]')
                            .removeClass('d-none')
                            .first()
                            .removeClass('d-none button--secondary')
                            .addClass('button--primary selected')
                            .siblings()
                            .removeClass('button--primary selected')
                            .addClass('button--secondary')
                            ;

                        $container
                            .find(this.dom._card_prod_options+this.dom._card_prod_options_swatch+' [for]')
                            .first()
                            .addClass('selected')
                            .siblings()
                            .removeClass('selected')
                            ;
    
                        // Select first item
                        $container
                            .find(this.dom._card_prod_options_var)
                            .each((x, el) => {
    
                                if (x == 0) {
                                    $(el)
                                        .removeClass('d-none')
                                        .find('button')
                                        .first()
                                        .trigger('click')
                                } else {
                                    $(el)
                                        .addClass('d-none')
                                        .find('button')
                                        .first()
                                        .removeClass('d-none button--secondary')
                                        .addClass('button--primary selected')
                                        .siblings()
                                        .removeClass('button--primary selected')
                                        .addClass('button--secondary')
                                        ;
                                }
    
                            });
    
                        $container.find(this.dom._card_info + '[data-view="default"]').show();
                        $container.find(this.dom._card_info + '[data-view="preselect"]').hide();
    
                    });
    
                }

            }).then(() => {

                this.update_ui__v2();
    
                _WAL.SiteProdCompatibility.reload();

            });

        });

    }

} new ProdConfig();

class ProdEngraving extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {

        container: '[data-el="product-configurator--container"][data-prod-handles*="engraving"]',

        _text_preview: '[data-el-engraving--preview]',
        _input_prefix: '',
        _input: '[data-el="product-configurator--cart-properties"]:not([type="hidden"])',
        _input_char_count: '[data-el-char-count]',
        _input_last_focus: 'data-last-focus-input',
        _img: '[data-el="product-configurator--image"]',

        _input_font_set: '[data-el="product-configurator--engraving-font"] button[data-value]',
        _input_emoji_set: '[data-el="product-configurator--engraving-emoji"] button[data-value]',
        _input_emoji_ctrl: '[data-el="product-configurator--engraving-emoji-ctrl"]',

    };

    config = {};
    cache = {
        active_engraving_settings: null,
    };

    _should_init() {
        let has_engraving = true;

        if (!this.dom.$container.length) { has_engraving = false; }
        if (!this.config.engraving) { has_engraving = false; }
        if (!this.config.engraving[window._WAL_CONFIG.product.id] && Object.keys(this.config.engraving).length == 1) { has_engraving = false; }
        
        return has_engraving;
    };

    load() {

        this.dom.$img.wrap('<div data-el-engraving--preview></div>');
        this.dom.$img.after('<div></div>');
        this.cache_dom();

    }

    loaded() {
        if (!this._should_init()) { return; }

        this.cache.active_engraving_settings = this.config.engraving[window._WAL_CONFIG.product.id] || null;

        this.apply_config();
        this.cache_dom();

        this.dom.$input_font_set.first().click();
    }

    bind() {

        this.dom.$container.on('focus', this.dom._input, (e) => {
            const $this = $(e.currentTarget);
            $this.removeClass('is-invalid').attr('placeholder', $this.data('default-placeholder'));
            $this.closest(this.dom.container).find(`[${this.dom._input_last_focus}]`).removeAttr(this.dom._input_last_focus);
            $this.attr(this.dom._input_last_focus, '');
        });
        this.dom.$container.on('keydown keyup change', this.dom._input, (e) => {
            const $this = $(e.currentTarget);

            $this.val( $this.val().replaceAll(/[a-z]+/g, x => x.toUpperCase()) );

            const char_count = Math.ceil(([...$this.val()].length / $this.data('maxlength')) * 100);
            if(char_count > 100) {
                $this.val([...$this.val()].slice(0, $this.data('maxlength')).join(''));
                return;
            }

            WAL_Apploader.register('ProdConfig', () => {
                window._WAL.ProdConfig.draft_cart__update_list();
                window._WAL.ProdConfig.update_ui__summary();
            });

            $this.siblings(this.dom._input_char_count).css('width', `${char_count}%`);

            //let text_val = this.config.engraving?.input_prefix ? this.config.engraving.input_prefix+' ' : '';
            let text_val = this.cache.active_engraving_settings?.input_prefix ? this.cache.active_engraving_settings.input_prefix+' ' : '';
            this.dom.$input.each((k, el) => text_val += $(el).val()+(k == (this.dom.$input.length-1) ? '' : '<br/>'));
            /* text_val = text_val
                // SPECIAL CHAR
                .replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '')
                // EMOJI WRAP
                .replace(/\p{RI}\p{RI}|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?(\u{200D}\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?)+|\p{EPres}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})/gu, '<span>$&</span>')
                .replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '<span>$&</span>')
                .replace(/[a-z]+/g, x => x.toUpperCase())
                .toUpperCase()
                .trim()
            ; */

            text_val = text_val.replaceAll(' ', ' &hairsp;');
            text_val = !(e.code == "Space" || e.keyCode == 32) ? text_val.trim() : text_val;

            $this.closest(this.dom.container).find(`${this.dom._text_preview} > div`).html(text_val);
        });

        this.dom.$input_font_set.on('click', (e) => {
            const $this = $(e.currentTarget);
            $this.closest('[data-el]').find('[data-active]').removeAttr('data-active');
            $this.attr('data-active', '');
            this.dom.$text_preview.find('> div').css('--font-family', $this.data('value'));
            $this.closest('[data-el]').find('input[type="hidden"]').val($this.data('value')).trigger('change');
        });

        this.dom.$input_emoji_set.on('click', (e) => {
            let $input = this.dom.$container.find(`${this.dom._input}[${this.dom._input_last_focus}]`);
            $input = $input.length ? $input : this.dom.$container.find(`${this.dom._input}`).first();

            if( [...$input.val()].length > $input.data('maxlength') ) { return; }

            $input.val($input.val()+e.currentTarget.dataset.value);
            $input.trigger('change');
        });

        this.dom.$input_emoji_ctrl.on('click', (e) => {
            const $this = $(e.currentTarget);
            const $target = $this.siblings('[data-el]');
            const el = $target.get(0);

            const next_scroll_pos = el.scrollLeft + el.clientWidth + 10; // add some padding to ensure the next emoji is fully visible
            const at_end = next_scroll_pos >= el.scrollWidth;

            el.scrollTo({
                left: at_end ? 0 : next_scroll_pos,
                behavior: "smooth",
            });
        });
    }

    get product_handle() {
        return this.dom.$input.closest(this.dom.container).data('prod-handles');
    }

    is_engraving($container) {
        return this.dom.$container.filter((k, el) => {
            const $el = $(el);
            return $el.find(this.dom._input).length
                && $el.find(this.dom._input_font_set).length
                && $(el).is($container)
        }).length > 0;
    }

    apply_config(config) {

        this.cache.active_engraving_settings = config || this.cache.active_engraving_settings;
        const conf = this.cache.active_engraving_settings;

        if (!conf) { return false; }

        let styles = {};

        if (conf['colour']) { // NOTE THE SPELLING
            styles['color'] = conf['colour'];
        }
        if (conf['font_size']) {
            styles['font-size'] = conf['font_size']+'px';
        }
        if (conf['line_height']) {
            styles['line-height'] = conf['line_height'] + 'px';
        }
        if (conf['letter_space']) {
            styles['letter-spacing'] = conf['letter_space'] + 'px';
        }
        if (conf['opacity']) {
            styles['opacity'] = conf['opacity'];
        }
        if (conf['left_offset']) {
            styles['left'] = 'calc(' + conf['left_offset'] + '%)';
        }
        if (conf['top_offset']) {
            styles['top'] = 'calc(' + conf['top_offset'] + '%)';
        }
        if (conf['rotate']) {
            styles['-moz-transform'] = 'translate(-50%, 0) rotate(' + conf['rotate'] + 'deg) translate(0, -50%)';
            styles['-webkit-transform'] = 'translate(-50%, 0) rotate(' + conf['rotate'] + 'deg) translate(0, -50%)';
            styles['-o-transform'] = 'translate(-50%, 0) rotate(' + conf['rotate'] + 'deg) translate(0, -50%)';
            styles['-ms-transform'] = 'translate(-50%, 0) rotate(' + conf['rotate'] + 'deg) translate(0, -50%)';
            styles['transform'] = 'translate(-50%, 0) rotate(' + conf['rotate'] + 'deg) translate(0, -50%)';
        }

        styles['--font-family'] = conf['font_family'] || this.dom.$input_font_set.filter('[data-active]').first().data('value') || this.dom.$input_font_set.first().data('value');
        //styles['font-family'] = conf['font_family'];

        // Apply CSS
        this.dom.$text_preview.find('> div').attr('style', '').css(styles);

        // SVG
        this.dom.$text_preview.find('svg').css({

            fill: styles['color'],
            height: styles['font-size'],
            display: 'inline-block',

        });

        if (conf['max_char']?.length > 0) {

            const inputs = conf['max_char'].replace(/\s/g,'').split(',').reverse();

            if( conf['max_char'].includes(',') && this.dom.$input.length < inputs.length ) {

                const $first_input = this.dom.$input.closest('.input-group');
                const $template = $first_input.clone();
                const $container = $first_input.parent();
                
                $container.find('.input-group').remove();

                inputs.forEach((max, index) => {

                    let clone = $template.clone();
                    let i = clone.find('input');
                    const placeholder_text = i.attr('placeholder').replace('14', max);
                    i.attr('data-maxlength', max)
                        .attr('placeholder', placeholder_text)
                        .attr('data-default-placeholder', placeholder_text)
                        .attr('name', 'Line '+(inputs.length-index))
                    ;

                    $container.prepend(clone);

                });

            } else {
                const placeholder_text = this.dom.$input.attr('placeholder').replace('14', conf['max_char']);
                this.dom.$input
                    .attr('placeholder', placeholder_text)
                    .attr('data-default-placeholder', placeholder_text)
                    .attr('maxlength', conf['max_char']);
            }

        }

        // set prefix if available
        if (conf['input_prefix'] && conf['input_prefix'] != '') {

            Custom_engraving.text_input_container.find('.addon-engraving-prefix')
                .html(conf['input_prefix'])
                .show();

            Custom_engraving.text_input.css('padding-left', Custom_engraving.text_input_container.find('.addon-engraving-prefix').outerWidth() + 'px');

        }

        return true;

    }

    to_img() {
        const container = this.dom.$input.closest(this.dom.container);
        const target_el = container.find(this.dom._text_preview).get(0);
        const img = target_el?.querySelector('img');

        if(!html2canvas ||!target_el || !img || !_WAL.ProdConfig.draft_cart[container.data('prod-handles')] ) { return new Promise((resolve, reject) => reject(false)); }

        img.crossOrigin = "anonymous";
        return this.to_base64(img.src).then(base64 => {
            img.src = base64;

            return html2canvas(target_el, {
                logging: false,
                useCORS: true,
                allowTaint: true,
                y: (() => parseInt(img?.currentStyle?.marginTop || window.getComputedStyle(img).marginTop) )(),
                x: (() => parseInt(img?.currentStyle?.marginLeft || window.getComputedStyle(img).marginLeft) )(),
                height: (() => img?.height || null )(),
                width: (() => img?.width || null )(),
            });
        });

    }

    download(fname = false) {
        fname = fname || this.config.product.id.toString().uuid4();
        return this.to_img().then(canvas => {
            const img = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = img;
            link.download = fname+'.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return img;
        })
        .catch(err => console.info('No image generated', err) );
    }

    upload(fname = false) {
        fname = fname || this.config.product.id.toString().uuid4();
        return this.to_img().then(canvas => {
            
            return new Promise(resolve => canvas.toBlob((blob) => {

                const formData = new FormData();
                formData.append('id', fname);
                formData.append('image', blob, fname + '.png');

                resolve( fetch(this.aws.lightsail+'/aws-s3', {
                    method: 'POST',
                    body: formData,
                }).then(res => res.json()) );

            }, 'image/png'));

        })
        .catch(err => console.info('No image generated', err) );
    }

    async to_base64(url) {
        try {
            // Fetch the image as a Blob
            const response = await fetch(url, { cache: "no-store", mode: "cors" });
            const blob = await response.blob();

            // Convert Blob to Base64
            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image to Base64:", error);
        }
    }

} new ProdEngraving();

class PageFaqs extends WAL {

    constructor() {
        super();
        this.init();
    }

    dom = {
        container: '.collapsible-content',
    };

    config = {
        resource_endpoint: '/blogs/faqs?view=json',
        storage_key: 'SITE--db-faqs-list',
    };

    cache = {};

    should_init() {
        return window.location.pathname.includes('/pages/faq');
    }

    load() {
        this.cache.data = JSON.parse(sessionStorage.getItem(this.config.storage_key)) || null;

        this.cache.data ? this.render_faqs() : fetch(this.config.resource_endpoint)
            .then((res) => res.json())
            .then((data) => {
                sessionStorage.setItem(this.config.storage_key, JSON.stringify(data));
                this.cache.data = data || {};
                this.render_faqs();
            });
    }

    get format_data() {
        let d = {};
        this.cache.data?.forEach(i => {
            //const handle = i.topic.dashcase() || 'general';
            const handle = sha256(i.topic.toLowerCase().trim()) || 'general';
            d[handle] = d[handle] || [];
            d[handle].push(i);
        });
        return d;
    }

    render_faqs() {
        $.each(this.format_data, (key, items) => {
            this.dom.$container.filter(`[data-handle="${key}"]`).each((k, el) => {
                const $el = $(el);
                const template = $el.find('template').html();
                const $container = $el.find('.grid__item');
                const open_first = $container.is('[data-open-first]');
                
                items.forEach(i => {
                    const item = template
                        .replaceAll('[[ HEADING ]]', i.title)
                        .replaceAll('[[ HTML ]]', i.body_html);

                    const $item = $(item);
                    const $details = $item.find('details');
                    const $sumnmary = $details.find('summary');

                    $details
                        .attr('id', $details.attr('id')+'-'+key+'-'+k)
                        .prop('open', open_first && (items.indexOf(i) === 0));
                    $sumnmary
                        .attr('aria-expanded', open_first && (items.indexOf(i) === 0));
                    $container.append($item);
                });
            });
        });

        this.dom.$container.on('click', 'details', (e) => {
            const $this = $(e.currentTarget);
            $this.find('summary').attr('aria-expanded', !$this.prop('open'));
        });

        if(!this.is_in_design_mode) {
            // hide container
            this.dom.$container.filter((k, el) => {
                return !$(el).find('.grid__item details').length;
            }).remove();
        } else {
            this.dom.$container.each((k, el) => {
                const $el = $(el);
                if(!$el.find('.grid__item details').length) {
                    const template = $el.find('template').html();
                    const $container = $el.find('.grid__item');
                    const item = template
                        .replaceAll('[[ HEADING ]]', 'Auto Generated Content')
                        .replaceAll('[[ HTML ]]', '---');

                    const $item = $(item);
                    const $details = $item.find('details');
                    const $sumnmary = $details.find('summary');

                    $details
                        .attr('id', $details.attr('id')+'-sample')
                        .prop('open', true);
                    $sumnmary
                        .attr('aria-expanded', true);
                    $container.append($item);
                }
            });
        }
    }

    bind() { }

} new PageFaqs();